function PlanO({ ...props }) {
	return (
		<g id="plan-o">
			<g id="furniture">
				<polyline
					points="188.6 679.62 186.17 679.62 186.17 674.82 188.6 674.82 188.6 679.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="426.63"
					y1="487.93"
					x2="463.07"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.63"
					y1="410.52"
					x2="426.63"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.07"
					y1="487.93"
					x2="463.07"
					y2="483.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.07"
					y1="480.13"
					x2="463.07"
					y2="474.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.07"
					y1="470.8"
					x2="463.07"
					y2="464.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.07"
					y1="461.47"
					x2="463.07"
					y2="455.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.07"
					y1="452.14"
					x2="463.07"
					y2="446.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.07"
					y1="442.81"
					x2="463.07"
					y2="436.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.31"
					y1="410.52"
					x2="438.48"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.98"
					y1="410.52"
					x2="429.05"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="410.52"
					x2="429.05"
					y2="414.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="418.32"
					x2="429.05"
					y2="424.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="427.65"
					x2="429.05"
					y2="433.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="436.98"
					x2="429.05"
					y2="442.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="446.31"
					x2="429.05"
					y2="452.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="455.64"
					x2="429.05"
					y2="461.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="464.97"
					x2="429.05"
					y2="470.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="474.3"
					x2="429.05"
					y2="480.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="483.63"
					x2="429.05"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.05"
					y1="487.93"
					x2="434.98"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.48"
					y1="487.93"
					x2="444.31"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.81"
					y1="487.93"
					x2="453.65"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.15"
					y1="487.93"
					x2="463.07"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="508.42"
					x2="608.2"
					y2="508.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="544.87"
					x2="769.19"
					y2="508.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.43"
					y1="544.87"
					x2="752.26"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.76"
					y1="544.87"
					x2="761.59"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.09"
					y1="544.87"
					x2="769.19"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="544.87"
					x2="769.19"
					y2="538.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="535.44"
					x2="769.19"
					y2="529.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="526.11"
					x2="769.19"
					y2="520.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="516.78"
					x2="769.19"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="510.85"
					x2="765.09"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.59"
					y1="510.85"
					x2="755.76"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.26"
					y1="510.85"
					x2="746.43"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.93"
					y1="510.85"
					x2="737.1"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.6"
					y1="510.85"
					x2="727.77"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.27"
					y1="510.85"
					x2="718.44"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.94"
					y1="510.85"
					x2="709.11"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.61"
					y1="510.85"
					x2="699.78"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.28"
					y1="510.85"
					x2="690.45"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.95"
					y1="510.85"
					x2="681.12"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.62"
					y1="510.85"
					x2="671.78"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.28"
					y1="510.85"
					x2="662.45"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.95"
					y1="510.85"
					x2="653.12"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.63"
					y1="510.85"
					x2="643.79"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.29"
					y1="510.85"
					x2="634.46"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.96"
					y1="510.85"
					x2="625.13"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.63"
					y1="510.85"
					x2="615.8"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.3"
					y1="510.85"
					x2="608.2"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="510.85"
					x2="608.2"
					y2="516.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="520.28"
					x2="608.2"
					y2="526.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.34"
					y1="508.42"
					x2="781.34"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.56"
					y1="508.42"
					x2="781.34"
					y2="508.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.34"
					y1="544.87"
					x2="784.22"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.72"
					y1="544.87"
					x2="793.55"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.05"
					y1="544.87"
					x2="802.88"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.38"
					y1="544.87"
					x2="812.22"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.71"
					y1="544.87"
					x2="821.55"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.04"
					y1="544.87"
					x2="830.87"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.37"
					y1="544.87"
					x2="840.21"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.7"
					y1="544.87"
					x2="849.54"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.04"
					y1="544.87"
					x2="858.87"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.37"
					y1="544.87"
					x2="868.2"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.7"
					y1="544.87"
					x2="877.53"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.03"
					y1="544.87"
					x2="886.86"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.56"
					y1="526.11"
					x2="930.56"
					y2="520.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.56"
					y1="516.78"
					x2="930.56"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.56"
					y1="510.85"
					x2="927.68"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.18"
					y1="510.85"
					x2="918.35"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.85"
					y1="510.85"
					x2="909.02"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.52"
					y1="510.85"
					x2="899.69"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.19"
					y1="510.85"
					x2="890.36"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.86"
					y1="510.85"
					x2="881.03"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.53"
					y1="510.85"
					x2="871.7"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.2"
					y1="510.85"
					x2="862.37"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.87"
					y1="510.85"
					x2="853.04"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.54"
					y1="510.85"
					x2="843.7"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.21"
					y1="510.85"
					x2="834.37"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.87"
					y1="510.85"
					x2="825.04"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.55"
					y1="510.85"
					x2="815.71"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.22"
					y1="510.85"
					x2="806.38"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.88"
					y1="510.85"
					x2="797.05"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.55"
					y1="510.85"
					x2="787.72"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.22"
					y1="510.85"
					x2="781.34"
					y2="510.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.34"
					y1="510.85"
					x2="781.34"
					y2="516.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.34"
					y1="520.28"
					x2="781.34"
					y2="526.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.34"
					y1="529.61"
					x2="781.34"
					y2="535.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.34"
					y1="538.94"
					x2="781.34"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="483.83 413.88 549.44 413.88 549.44 479.49 483.83 479.49 483.83 413.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="273.11 156.85 232.51 156.85 232.51 162.11 273.11 162.11 273.11 156.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="230.6 156.37 275.03 156.37 275.03 156.85 230.6 156.85 230.6 156.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="230.6"
					y1="156.37"
					x2="275.03"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.03"
					y1="156.37"
					x2="275.03"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.03"
					y1="156.85"
					x2="230.6"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.6"
					y1="156.85"
					x2="230.6"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.11"
					y1="162.11"
					x2="232.51"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.51"
					y1="156.85"
					x2="273.11"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.42 162.11 273.11 162.11 273.11 156.85 277.42 156.85 277.42 162.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="277.42"
					y1="162.11"
					x2="273.11"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.11"
					y1="162.11"
					x2="273.11"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.11"
					y1="156.85"
					x2="277.42"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.42"
					y1="156.85"
					x2="277.42"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="228.21 156.85 232.51 156.85 232.51 162.11 228.21 162.11 228.21 156.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="228.21"
					y1="156.85"
					x2="232.51"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.51"
					y1="156.85"
					x2="232.51"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.51"
					y1="162.11"
					x2="228.21"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.21"
					y1="162.11"
					x2="228.21"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.11"
					y1="157.8"
					x2="232.51"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="279.33 161.63 277.42 161.63 277.42 156.85 275.03 156.85 275.03 156.37 279.33 156.37 279.33 161.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="279.33"
					y1="161.63"
					x2="277.42"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.42"
					y1="161.63"
					x2="277.42"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.42"
					y1="156.85"
					x2="275.03"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.03"
					y1="156.85"
					x2="275.03"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.03"
					y1="156.37"
					x2="279.33"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.33"
					y1="156.37"
					x2="279.33"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="226.3 156.37 230.6 156.37 230.6 156.85 228.21 156.85 228.21 161.63 226.3 161.63 226.3 156.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="226.3"
					y1="156.37"
					x2="230.6"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.6"
					y1="156.37"
					x2="230.6"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.6"
					y1="156.85"
					x2="228.21"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.21"
					y1="156.85"
					x2="228.21"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.21"
					y1="161.63"
					x2="226.3"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.3"
					y1="161.63"
					x2="226.3"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="223.87 157.8 223.87 160.23 125.16 160.23 125.16 157.8 223.87 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="223.87"
					y1="157.8"
					x2="223.87"
					y2="160.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.87"
					y1="160.23"
					x2="125.16"
					y2="160.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.16"
					y1="160.23"
					x2="125.16"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.16"
					y1="157.8"
					x2="223.87"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="279.33 157.8 284.19 157.8 284.19 172.38 279.33 172.38 279.33 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.19"
					y1="157.8"
					x2="279.33"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.19"
					y1="172.38"
					x2="284.19"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.33"
					y1="172.38"
					x2="284.19"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.33"
					y1="157.8"
					x2="279.33"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.44 157.8 226.3 157.8 226.3 172.38 221.44 172.38 221.44 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="226.3"
					y1="157.8"
					x2="221.44"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.3"
					y1="172.38"
					x2="226.3"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.44"
					y1="172.38"
					x2="226.3"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.44"
					y1="157.8"
					x2="221.44"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="122.73 157.8 127.59 157.8 127.59 172.38 122.73 172.38 122.73 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="127.59"
					y1="157.8"
					x2="122.73"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.59"
					y1="172.38"
					x2="127.59"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.73"
					y1="172.38"
					x2="127.59"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.73"
					y1="157.8"
					x2="122.73"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="564.53 156.85 523.93 156.85 523.93 162.11 564.53 162.11 564.53 156.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="522.02 156.37 566.44 156.37 566.44 156.85 522.02 156.85 522.02 156.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="522.02"
					y1="156.37"
					x2="566.44"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="156.37"
					x2="566.44"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="156.85"
					x2="522.02"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.02"
					y1="156.85"
					x2="522.02"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.53"
					y1="162.11"
					x2="523.93"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.93"
					y1="156.85"
					x2="564.53"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="568.83 162.11 564.53 162.11 564.53 156.85 568.83 156.85 568.83 162.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="568.83"
					y1="162.11"
					x2="564.53"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.53"
					y1="162.11"
					x2="564.53"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.53"
					y1="156.85"
					x2="568.83"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.83"
					y1="156.85"
					x2="568.83"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="519.62 156.85 523.93 156.85 523.93 162.11 519.62 162.11 519.62 156.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="519.62"
					y1="156.85"
					x2="523.93"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.93"
					y1="156.85"
					x2="523.93"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.93"
					y1="162.11"
					x2="519.62"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.62"
					y1="162.11"
					x2="519.62"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.53"
					y1="157.8"
					x2="523.93"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="570.74 161.63 568.83 161.63 568.83 156.85 566.44 156.85 566.44 156.37 570.74 156.37 570.74 161.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="570.74"
					y1="161.63"
					x2="568.83"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.83"
					y1="161.63"
					x2="568.83"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.83"
					y1="156.85"
					x2="566.44"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="156.85"
					x2="566.44"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="156.37"
					x2="570.74"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.74"
					y1="156.37"
					x2="570.74"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="517.71 156.37 522.02 156.37 522.02 156.85 519.62 156.85 519.62 161.63 517.71 161.63 517.71 156.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="517.71"
					y1="156.37"
					x2="522.02"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.02"
					y1="156.37"
					x2="522.02"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.02"
					y1="156.85"
					x2="519.62"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.62"
					y1="156.85"
					x2="519.62"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.62"
					y1="161.63"
					x2="517.71"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.71"
					y1="161.63"
					x2="517.71"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="515.28 157.8 515.28 160.23 430.9 160.23 430.9 157.8 515.28 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="515.28"
					y1="157.8"
					x2="515.28"
					y2="160.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.28"
					y1="160.23"
					x2="430.9"
					y2="160.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.9"
					y1="160.23"
					x2="430.9"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.9"
					y1="157.8"
					x2="515.28"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="570.74 157.8 575.6 157.8 575.6 172.38 570.74 172.38 570.74 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="575.6"
					y1="157.8"
					x2="570.74"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.6"
					y1="172.38"
					x2="575.6"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.74"
					y1="172.38"
					x2="575.6"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.74"
					y1="157.8"
					x2="570.74"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="512.85 157.8 517.71 157.8 517.71 172.38 512.85 172.38 512.85 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="517.71"
					y1="157.8"
					x2="512.85"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.71"
					y1="172.38"
					x2="517.71"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.85"
					y1="172.38"
					x2="517.71"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.85"
					y1="157.8"
					x2="512.85"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="428.46 157.8 433.33 157.8 433.33 172.38 428.46 172.38 428.46 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="433.33"
					y1="157.8"
					x2="428.46"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.33"
					y1="172.38"
					x2="433.33"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.46"
					y1="172.38"
					x2="433.33"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.46"
					y1="157.8"
					x2="428.46"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="899.98 156.85 859.39 156.85 859.39 162.11 899.98 162.11 899.98 156.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="857.47 156.37 901.9 156.37 901.9 156.85 857.47 156.85 857.47 156.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="857.47"
					y1="156.37"
					x2="901.9"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.9"
					y1="156.37"
					x2="901.9"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.9"
					y1="156.85"
					x2="857.47"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.47"
					y1="156.85"
					x2="857.47"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.98"
					y1="162.11"
					x2="859.39"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.39"
					y1="156.85"
					x2="899.98"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="904.29 162.11 899.98 162.11 899.98 156.85 904.29 156.85 904.29 162.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="904.29"
					y1="162.11"
					x2="899.98"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.98"
					y1="162.11"
					x2="899.98"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.98"
					y1="156.85"
					x2="904.29"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.29"
					y1="156.85"
					x2="904.29"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="855.08 156.85 859.39 156.85 859.39 162.11 855.08 162.11 855.08 156.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="855.08"
					y1="156.85"
					x2="859.39"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.39"
					y1="156.85"
					x2="859.39"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.39"
					y1="162.11"
					x2="855.08"
					y2="162.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.08"
					y1="162.11"
					x2="855.08"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.98"
					y1="157.8"
					x2="859.39"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="906.2 161.63 904.29 161.63 904.29 156.85 901.9 156.85 901.9 156.37 906.2 156.37 906.2 161.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="906.2"
					y1="161.63"
					x2="904.29"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.29"
					y1="161.63"
					x2="904.29"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.29"
					y1="156.85"
					x2="901.9"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.9"
					y1="156.85"
					x2="901.9"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.9"
					y1="156.37"
					x2="906.2"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.2"
					y1="156.37"
					x2="906.2"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="853.17 156.37 857.47 156.37 857.47 156.85 855.08 156.85 855.08 161.63 853.17 161.63 853.17 156.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="853.17"
					y1="156.37"
					x2="857.47"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.47"
					y1="156.37"
					x2="857.47"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.47"
					y1="156.85"
					x2="855.08"
					y2="156.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.08"
					y1="156.85"
					x2="855.08"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.08"
					y1="161.63"
					x2="853.17"
					y2="161.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.17"
					y1="161.63"
					x2="853.17"
					y2="156.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="850.74 157.8 850.74 160.23 722.35 160.23 722.35 157.8 850.74 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="850.74"
					y1="157.8"
					x2="850.74"
					y2="160.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.74"
					y1="160.23"
					x2="722.35"
					y2="160.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.35"
					y1="160.23"
					x2="722.35"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.35"
					y1="157.8"
					x2="850.74"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="906.2 157.8 911.06 157.8 911.06 172.38 906.2 172.38 906.2 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="911.06"
					y1="157.8"
					x2="906.2"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.06"
					y1="172.38"
					x2="911.06"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.2"
					y1="172.38"
					x2="911.06"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.2"
					y1="157.8"
					x2="906.2"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="848.31 157.8 853.17 157.8 853.17 172.38 848.31 172.38 848.31 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="853.17"
					y1="157.8"
					x2="848.31"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.17"
					y1="172.38"
					x2="853.17"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.31"
					y1="172.38"
					x2="853.17"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.31"
					y1="157.8"
					x2="848.31"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="719.92 157.8 724.78 157.8 724.78 172.38 719.92 172.38 719.92 157.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="724.78"
					y1="157.8"
					x2="719.92"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.78"
					y1="172.38"
					x2="724.78"
					y2="157.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.92"
					y1="172.38"
					x2="724.78"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.92"
					y1="157.8"
					x2="719.92"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.44"
					y1="845.84"
					x2="264.8"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="826.4"
					x2="264.8"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="826.4"
					x2="268.44"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.78"
					y1="845.84"
					x2="364.42"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.78"
					y1="826.4"
					x2="364.42"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.78"
					y1="826.4"
					x2="360.78"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="826.4"
					x2="264.23"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="359.56 847.05 364.42 847.05 364.42 845.84 359.56 845.84 359.56 847.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="269.66 845.84 264.8 845.84 264.8 847.05 269.66 847.05 269.66 845.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="359.56 826.4 364.42 826.4 364.42 825.19 359.56 825.19 359.56 826.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="269.66 825.19 264.8 825.19 264.8 826.4 269.66 826.4 269.66 825.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="359.56"
					y1="847.05"
					x2="364.42"
					y2="847.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.42"
					y1="847.05"
					x2="364.42"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.42"
					y1="845.84"
					x2="359.56"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.56"
					y1="845.84"
					x2="359.56"
					y2="847.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.66"
					y1="845.84"
					x2="264.8"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.8"
					y1="845.84"
					x2="264.8"
					y2="847.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.8"
					y1="847.05"
					x2="269.66"
					y2="847.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.66"
					y1="847.05"
					x2="269.66"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.56"
					y1="826.4"
					x2="364.42"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.42"
					y1="826.4"
					x2="364.42"
					y2="825.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.42"
					y1="825.19"
					x2="359.56"
					y2="825.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.56"
					y1="825.19"
					x2="359.56"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.66"
					y1="825.19"
					x2="264.8"
					y2="825.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.8"
					y1="825.19"
					x2="264.8"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.8"
					y1="826.4"
					x2="269.66"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.66"
					y1="826.4"
					x2="269.66"
					y2="825.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="358.35 845.84 360.17 845.84 360.17 826.4 358.35 826.4 358.35 845.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="269.05 845.84 270.87 845.84 270.87 826.4 269.05 826.4 269.05 845.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="332.73 764.55 270.87 826.4 273.88 829.41 335.73 767.55 332.73 764.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="360.17"
					y1="826.4"
					x2="360.78"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.17"
					y1="845.84"
					x2="360.78"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.78"
					y1="826.4"
					x2="360.78"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.05"
					y1="826.4"
					x2="268.44"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.05"
					y1="845.84"
					x2="268.44"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.44"
					y1="826.4"
					x2="268.44"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.35"
					y1="845.84"
					x2="358.35"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.35"
					y1="826.4"
					x2="360.17"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.17"
					y1="826.4"
					x2="360.17"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.17"
					y1="845.84"
					x2="358.35"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.05"
					y1="845.84"
					x2="269.05"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.05"
					y1="826.4"
					x2="270.87"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.87"
					y1="826.4"
					x2="270.87"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.87"
					y1="845.84"
					x2="269.05"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.73"
					y1="764.55"
					x2="335.73"
					y2="767.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.73"
					y1="767.55"
					x2="273.88"
					y2="829.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.88"
					y1="829.41"
					x2="270.87"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.87"
					y1="826.4"
					x2="332.73"
					y2="764.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.78"
					y1="826.4"
					x2="360.78"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.78"
					y1="826.4"
					x2="360.78"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.78"
					y1="826.4"
					x2="364.42"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.78"
					y1="826.4"
					x2="364.42"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.78"
					y1="845.84"
					x2="364.42"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.78"
					y1="845.84"
					x2="364.42"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="826.4"
					x2="268.44"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="826.4"
					x2="268.44"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="826.4"
					x2="264.8"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="826.4"
					x2="264.8"
					y2="826.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="845.84"
					x2="264.8"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="268.44"
					y1="845.84"
					x2="264.8"
					y2="845.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="264.23"
					y1="767.7"
					x2="244.79"
					y2="767.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="244.79"
					y1="767.7"
					x2="183.74"
					y2="767.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="183.74"
					y1="767.7"
					x2="183.74"
					y2="746.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="183.74"
					y1="746.06"
					x2="164.3"
					y2="746.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="164.3"
					y1="746.06"
					x2="76.41"
					y2="746.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="76.41"
					y1="746.06"
					x2="76.41"
					y2="453.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="122.73"
					y1="152.95"
					x2="122.73"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="596.05"
					y1="385.25"
					x2="596.05"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="385.25"
					x2="608.2"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="385.25"
					x2="596.05"
					y2="385.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="596.05"
					y1="307.49"
					x2="596.05"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="307.49"
					x2="608.2"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="307.49"
					x2="596.05"
					y2="307.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="594.83 308.71 596.05 308.71 596.05 303.85 594.83 303.85 594.83 308.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.05 384.04 594.83 384.04 594.83 388.89 596.05 388.89 596.05 384.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="608.2 308.71 609.41 308.71 609.41 303.85 608.2 303.85 608.2 308.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="609.41 384.04 608.2 384.04 608.2 388.89 609.41 388.89 609.41 384.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="594.83"
					y1="308.71"
					x2="594.83"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.83"
					y1="303.85"
					x2="596.05"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="303.85"
					x2="596.05"
					y2="308.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="308.71"
					x2="594.83"
					y2="308.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="384.04"
					x2="596.05"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="388.89"
					x2="594.83"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.83"
					y1="388.89"
					x2="594.83"
					y2="384.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.83"
					y1="384.04"
					x2="596.05"
					y2="384.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="308.71"
					x2="608.2"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="303.85"
					x2="609.41"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.41"
					y1="303.85"
					x2="609.41"
					y2="308.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.41"
					y1="308.71"
					x2="608.2"
					y2="308.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.41"
					y1="384.04"
					x2="609.41"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.41"
					y1="388.89"
					x2="608.2"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="388.89"
					x2="608.2"
					y2="384.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="384.04"
					x2="609.41"
					y2="384.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="596.05 309.92 608.2 309.92 608.2 308.1 596.05 308.1 596.05 309.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.05 384.64 608.2 384.64 608.2 382.82 596.05 382.82 596.05 384.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="659.74 331.28 656.74 328.27 605.19 379.81 608.2 382.82 659.74 331.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="608.2"
					y1="308.1"
					x2="608.2"
					y2="307.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="308.1"
					x2="596.05"
					y2="307.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="307.49"
					x2="596.05"
					y2="307.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="384.64"
					x2="608.2"
					y2="385.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="384.64"
					x2="596.05"
					y2="385.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="385.25"
					x2="596.05"
					y2="385.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="309.92"
					x2="608.2"
					y2="309.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="309.92"
					x2="608.2"
					y2="308.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="308.1"
					x2="596.05"
					y2="308.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="308.1"
					x2="596.05"
					y2="309.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="384.64"
					x2="608.2"
					y2="384.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="384.64"
					x2="608.2"
					y2="382.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="382.82"
					x2="596.05"
					y2="382.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.05"
					y1="382.82"
					x2="596.05"
					y2="384.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.74"
					y1="331.28"
					x2="656.74"
					y2="328.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.74"
					y1="328.27"
					x2="605.19"
					y2="379.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.19"
					y1="379.81"
					x2="608.2"
					y2="382.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="382.82"
					x2="659.74"
					y2="331.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.2"
					y1="307.49"
					x2="596.05"
					y2="307.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="307.49"
					x2="596.05"
					y2="307.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="307.49"
					x2="608.2"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="307.49"
					x2="608.2"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="596.05"
					y1="307.49"
					x2="596.05"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="596.05"
					y1="307.49"
					x2="596.05"
					y2="303.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="385.25"
					x2="596.05"
					y2="385.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="385.25"
					x2="596.05"
					y2="385.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="385.25"
					x2="608.2"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="385.25"
					x2="608.2"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="596.05"
					y1="385.25"
					x2="596.05"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="596.05"
					y1="385.25"
					x2="596.05"
					y2="388.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="490.32"
					x2="619.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="487.89"
					x2="622.82"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="478.17"
					x2="619.79"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="478.17"
					x2="622.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="490.32"
					x2="753.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="487.89"
					x2="750.39"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="478.17"
					x2="753.43"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="478.17"
					x2="750.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="490.32"
					x2="794.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="487.89"
					x2="797.82"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="478.17"
					x2="794.79"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="478.17"
					x2="797.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="490.32"
					x2="928.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="487.89"
					x2="925.39"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="478.17"
					x2="928.43"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="478.17"
					x2="925.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="608.2"
					y1="490.32"
					x2="622.82"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="490.32"
					x2="769.19"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="781.34"
					y1="490.32"
					x2="797.82"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="490.32"
					x2="930.56"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="930.56"
					y1="478.17"
					x2="925.39"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="478.17"
					x2="750.39"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="478.17"
					x2="608.2"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="748.57 487.89 748.57 490.32 749.78 490.32 749.78 487.89 748.57 487.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="748.57 491.54 753.43 491.54 753.43 490.32 748.57 490.32 748.57 491.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="623.43 487.89 623.43 490.32 624.65 490.32 624.65 487.89 623.43 487.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="624.65 490.32 619.79 490.32 619.79 491.54 624.65 491.54 624.65 490.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="748.57 478.17 753.43 478.17 753.43 475.14 748.57 475.14 748.57 478.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="624.65 475.14 619.79 475.14 619.79 478.17 624.65 478.17 624.65 475.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="748.57"
					y1="487.89"
					x2="748.57"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.57"
					y1="490.32"
					x2="749.78"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.78"
					y1="490.32"
					x2="749.78"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.78"
					y1="487.89"
					x2="748.57"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.57"
					y1="491.54"
					x2="753.43"
					y2="491.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.43"
					y1="491.54"
					x2="753.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.43"
					y1="490.32"
					x2="748.57"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.57"
					y1="490.32"
					x2="748.57"
					y2="491.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.43"
					y1="487.89"
					x2="623.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.43"
					y1="490.32"
					x2="624.65"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.65"
					y1="490.32"
					x2="624.65"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.65"
					y1="487.89"
					x2="623.43"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.65"
					y1="490.32"
					x2="619.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.79"
					y1="490.32"
					x2="619.79"
					y2="491.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.79"
					y1="491.54"
					x2="624.65"
					y2="491.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.65"
					y1="491.54"
					x2="624.65"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.57"
					y1="478.17"
					x2="753.43"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.43"
					y1="478.17"
					x2="753.43"
					y2="475.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.43"
					y1="475.14"
					x2="748.57"
					y2="475.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.57"
					y1="475.14"
					x2="748.57"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.65"
					y1="475.14"
					x2="619.79"
					y2="475.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.79"
					y1="475.14"
					x2="619.79"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.79"
					y1="478.17"
					x2="624.65"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.65"
					y1="478.17"
					x2="624.65"
					y2="475.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="744.92 487.89 749.78 487.89 749.78 478.17 744.92 478.17 744.92 487.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="623.43 487.89 628.29 487.89 628.29 478.17 623.43 478.17 623.43 487.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="689.04 478.17 628.29 478.17 628.29 482.42 689.04 482.42 689.04 478.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="715.76 482.42 655.02 482.42 655.02 486.68 715.76 486.68 715.76 482.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="749.78"
					y1="478.17"
					x2="750.39"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.78"
					y1="487.89"
					x2="750.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.39"
					y1="478.17"
					x2="750.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.43"
					y1="478.17"
					x2="622.82"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.43"
					y1="487.89"
					x2="622.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.82"
					y1="478.17"
					x2="622.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.92"
					y1="487.89"
					x2="744.92"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.92"
					y1="478.17"
					x2="749.78"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.78"
					y1="478.17"
					x2="749.78"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.78"
					y1="487.89"
					x2="744.92"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.43"
					y1="487.89"
					x2="623.43"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.43"
					y1="478.17"
					x2="628.29"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.29"
					y1="478.17"
					x2="628.29"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.29"
					y1="487.89"
					x2="623.43"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.04"
					y1="478.17"
					x2="689.04"
					y2="482.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.04"
					y1="482.42"
					x2="628.29"
					y2="482.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.29"
					y1="482.42"
					x2="628.29"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.29"
					y1="478.17"
					x2="689.04"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.76"
					y1="482.42"
					x2="715.76"
					y2="486.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.76"
					y1="486.68"
					x2="655.02"
					y2="486.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.02"
					y1="486.68"
					x2="655.02"
					y2="482.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.02"
					y1="482.42"
					x2="715.76"
					y2="482.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.39"
					y1="478.17"
					x2="750.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="478.17"
					x2="750.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="487.89"
					x2="750.39"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="478.17"
					x2="753.43"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="487.89"
					x2="750.39"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="490.32"
					x2="753.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.39"
					y1="490.32"
					x2="753.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="478.17"
					x2="622.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="478.17"
					x2="622.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="487.89"
					x2="622.82"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="478.17"
					x2="619.79"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="487.89"
					x2="622.82"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="490.32"
					x2="619.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.82"
					y1="490.32"
					x2="619.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="923.57 487.89 923.57 490.32 924.79 490.32 924.79 487.89 923.57 487.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="923.57 491.54 928.43 491.54 928.43 490.32 923.57 490.32 923.57 491.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="798.43 487.89 798.43 490.32 799.64 490.32 799.64 487.89 798.43 487.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="799.64 490.32 794.79 490.32 794.79 491.54 799.64 491.54 799.64 490.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="923.57 478.17 928.43 478.17 928.43 475.14 923.57 475.14 923.57 478.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="799.64 475.14 794.79 475.14 794.79 478.17 799.64 478.17 799.64 475.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="923.57"
					y1="487.89"
					x2="923.57"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.57"
					y1="490.32"
					x2="924.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.79"
					y1="490.32"
					x2="924.79"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.79"
					y1="487.89"
					x2="923.57"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.57"
					y1="491.54"
					x2="928.43"
					y2="491.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.43"
					y1="491.54"
					x2="928.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.43"
					y1="490.32"
					x2="923.57"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.57"
					y1="490.32"
					x2="923.57"
					y2="491.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.43"
					y1="487.89"
					x2="798.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.43"
					y1="490.32"
					x2="799.64"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.64"
					y1="490.32"
					x2="799.64"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.64"
					y1="487.89"
					x2="798.43"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.64"
					y1="490.32"
					x2="794.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.79"
					y1="490.32"
					x2="794.79"
					y2="491.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.79"
					y1="491.54"
					x2="799.64"
					y2="491.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.64"
					y1="491.54"
					x2="799.64"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.57"
					y1="478.17"
					x2="928.43"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.43"
					y1="478.17"
					x2="928.43"
					y2="475.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.43"
					y1="475.14"
					x2="923.57"
					y2="475.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.57"
					y1="475.14"
					x2="923.57"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.64"
					y1="475.14"
					x2="794.79"
					y2="475.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.79"
					y1="475.14"
					x2="794.79"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.79"
					y1="478.17"
					x2="799.64"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.64"
					y1="478.17"
					x2="799.64"
					y2="475.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="919.92 487.89 924.79 487.89 924.79 478.17 919.92 478.17 919.92 487.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="798.43 487.89 803.29 487.89 803.29 478.17 798.43 478.17 798.43 487.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="864.04 478.17 803.29 478.17 803.29 482.42 864.04 482.42 864.04 478.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="890.77 482.42 830.02 482.42 830.02 486.68 890.77 486.68 890.77 482.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="924.79"
					y1="478.17"
					x2="925.39"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.79"
					y1="487.89"
					x2="925.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.39"
					y1="478.17"
					x2="925.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.43"
					y1="478.17"
					x2="797.82"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.43"
					y1="487.89"
					x2="797.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.82"
					y1="478.17"
					x2="797.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.92"
					y1="487.89"
					x2="919.92"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.92"
					y1="478.17"
					x2="924.79"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.79"
					y1="478.17"
					x2="924.79"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.79"
					y1="487.89"
					x2="919.92"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.43"
					y1="487.89"
					x2="798.43"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.43"
					y1="478.17"
					x2="803.29"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.29"
					y1="478.17"
					x2="803.29"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.29"
					y1="487.89"
					x2="798.43"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.04"
					y1="478.17"
					x2="864.04"
					y2="482.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.04"
					y1="482.42"
					x2="803.29"
					y2="482.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.29"
					y1="482.42"
					x2="803.29"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.29"
					y1="478.17"
					x2="864.04"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.77"
					y1="482.42"
					x2="890.77"
					y2="486.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.77"
					y1="486.68"
					x2="830.02"
					y2="486.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.02"
					y1="486.68"
					x2="830.02"
					y2="482.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.02"
					y1="482.42"
					x2="890.77"
					y2="482.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.39"
					y1="478.17"
					x2="925.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="478.17"
					x2="925.39"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="487.89"
					x2="925.39"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="478.17"
					x2="928.43"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="487.89"
					x2="925.39"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="490.32"
					x2="928.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="925.39"
					y1="490.32"
					x2="928.43"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="478.17"
					x2="797.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="478.17"
					x2="797.82"
					y2="487.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="487.89"
					x2="797.82"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="478.17"
					x2="794.79"
					y2="478.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="487.89"
					x2="797.82"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="490.32"
					x2="794.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="797.82"
					y1="490.32"
					x2="794.79"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="769.19"
					y1="490.32"
					x2="769.19"
					y2="544.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="781.34"
					y1="544.87"
					x2="781.34"
					y2="490.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="703.75"
					x2="397.16"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="703.75"
					x2="409.31"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="703.75"
					x2="397.16"
					y2="703.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="625.99"
					x2="397.16"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="625.99"
					x2="409.31"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="625.99"
					x2="397.16"
					y2="625.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="415.05"
					x2="409.31"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="415.05"
					x2="397.16"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="415.05"
					x2="409.31"
					y2="415.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="483.09"
					x2="409.31"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="483.09"
					x2="397.16"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="483.09"
					x2="409.31"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="487.93"
					x2="409.31"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="415.05"
					x2="409.31"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="398.37"
					x2="397.16"
					y2="415.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="395.95 627.21 397.16 627.21 397.16 622.34 395.95 622.34 395.95 627.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="397.16 702.53 395.95 702.53 395.95 707.39 397.16 707.39 397.16 702.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="409.31 627.21 410.52 627.21 410.52 622.34 409.31 622.34 409.31 627.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="410.52 702.53 409.31 702.53 409.31 707.39 410.52 707.39 410.52 702.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="395.95"
					y1="627.21"
					x2="395.95"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.95"
					y1="622.34"
					x2="397.16"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="622.34"
					x2="397.16"
					y2="627.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="627.21"
					x2="395.95"
					y2="627.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="702.53"
					x2="397.16"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="707.39"
					x2="395.95"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.95"
					y1="707.39"
					x2="395.95"
					y2="702.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.95"
					y1="702.53"
					x2="397.16"
					y2="702.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="627.21"
					x2="409.31"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="622.34"
					x2="410.52"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.52"
					y1="622.34"
					x2="410.52"
					y2="627.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.52"
					y1="627.21"
					x2="409.31"
					y2="627.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.52"
					y1="702.53"
					x2="410.52"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.52"
					y1="707.39"
					x2="409.31"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="707.39"
					x2="409.31"
					y2="702.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="702.53"
					x2="410.52"
					y2="702.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="397.16 628.42 409.31 628.42 409.31 626.6 397.16 626.6 397.16 628.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="397.16 703.14 409.31 703.14 409.31 701.32 397.16 701.32 397.16 703.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="460.86 649.77 457.85 646.76 406.3 698.31 409.31 701.32 460.86 649.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="409.31"
					y1="626.6"
					x2="409.31"
					y2="625.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="626.6"
					x2="397.16"
					y2="625.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="625.99"
					x2="397.16"
					y2="625.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="703.14"
					x2="409.31"
					y2="703.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="703.14"
					x2="397.16"
					y2="703.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="703.75"
					x2="397.16"
					y2="703.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="628.42"
					x2="409.31"
					y2="628.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="628.42"
					x2="409.31"
					y2="626.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="626.6"
					x2="397.16"
					y2="626.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="626.6"
					x2="397.16"
					y2="628.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="703.14"
					x2="409.31"
					y2="703.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="703.14"
					x2="409.31"
					y2="701.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="701.32"
					x2="397.16"
					y2="701.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="701.32"
					x2="397.16"
					y2="703.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.86"
					y1="649.77"
					x2="457.85"
					y2="646.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.85"
					y1="646.76"
					x2="406.3"
					y2="698.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.3"
					y1="698.31"
					x2="409.31"
					y2="701.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="701.32"
					x2="460.86"
					y2="649.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="625.99"
					x2="397.16"
					y2="625.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="625.99"
					x2="397.16"
					y2="625.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="625.99"
					x2="409.31"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="625.99"
					x2="409.31"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="625.99"
					x2="397.16"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="625.99"
					x2="397.16"
					y2="622.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="703.75"
					x2="397.16"
					y2="703.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="703.75"
					x2="397.16"
					y2="703.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="703.75"
					x2="409.31"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="703.75"
					x2="409.31"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="703.75"
					x2="397.16"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="703.75"
					x2="397.16"
					y2="707.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="410.52 481.87 409.31 481.87 409.31 486.73 410.52 486.73 410.52 481.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="409.31 416.26 410.52 416.26 410.52 411.4 409.31 411.4 409.31 416.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="397.16 481.87 395.95 481.87 395.95 486.73 397.16 486.73 397.16 481.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="395.95 416.26 397.16 416.26 397.16 411.4 395.95 411.4 395.95 416.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="410.52"
					y1="481.87"
					x2="410.52"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.52"
					y1="486.73"
					x2="409.31"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="486.73"
					x2="409.31"
					y2="481.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="481.87"
					x2="410.52"
					y2="481.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="416.26"
					x2="409.31"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="411.4"
					x2="410.52"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.52"
					y1="411.4"
					x2="410.52"
					y2="416.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.52"
					y1="416.26"
					x2="409.31"
					y2="416.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="481.87"
					x2="397.16"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="486.73"
					x2="395.95"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.95"
					y1="486.73"
					x2="395.95"
					y2="481.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.95"
					y1="481.87"
					x2="397.16"
					y2="481.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.95"
					y1="416.26"
					x2="395.95"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.95"
					y1="411.4"
					x2="397.16"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="411.4"
					x2="397.16"
					y2="416.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="416.26"
					x2="395.95"
					y2="416.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="409.31 480.65 397.16 480.65 397.16 482.48 409.31 482.48 409.31 480.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="409.31 415.66 397.16 415.66 397.16 417.48 409.31 417.48 409.31 415.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="352.49 462.15 355.49 465.16 400.17 420.49 397.16 417.48 352.49 462.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="397.16"
					y1="482.48"
					x2="397.16"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="482.48"
					x2="409.31"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="483.09"
					x2="409.31"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="415.66"
					x2="397.16"
					y2="415.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="415.66"
					x2="409.31"
					y2="415.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="415.05"
					x2="409.31"
					y2="415.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="480.65"
					x2="397.16"
					y2="480.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="480.65"
					x2="397.16"
					y2="482.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="482.48"
					x2="409.31"
					y2="482.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="482.48"
					x2="409.31"
					y2="480.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="415.66"
					x2="397.16"
					y2="415.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="415.66"
					x2="397.16"
					y2="417.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="417.48"
					x2="409.31"
					y2="417.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="417.48"
					x2="409.31"
					y2="415.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.49"
					y1="462.15"
					x2="355.49"
					y2="465.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.49"
					y1="465.16"
					x2="400.17"
					y2="420.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.17"
					y1="420.49"
					x2="397.16"
					y2="417.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="417.48"
					x2="352.49"
					y2="462.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="483.09"
					x2="409.31"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="483.09"
					x2="409.31"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="483.09"
					x2="397.16"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="483.09"
					x2="397.16"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="483.09"
					x2="409.31"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="483.09"
					x2="409.31"
					y2="486.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="415.05"
					x2="409.31"
					y2="415.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="415.05"
					x2="409.31"
					y2="415.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="415.05"
					x2="397.16"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="415.05"
					x2="397.16"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="415.05"
					x2="409.31"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="415.05"
					x2="409.31"
					y2="411.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="410.52"
					x2="479.72"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="398.37"
					x2="479.72"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="398.37"
					x2="483.36"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.4"
					y1="410.52"
					x2="555.04"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.4"
					y1="398.37"
					x2="555.04"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.4"
					y1="398.37"
					x2="551.4"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="475.22"
					y1="410.52"
					x2="483.36"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="397.16"
					y1="398.37"
					x2="409.31"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="550.18 411.73 555.04 411.73 555.04 410.52 550.18 410.52 550.18 411.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="484.58 410.52 479.72 410.52 479.72 411.73 484.58 411.73 484.58 410.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="550.18 398.37 555.04 398.37 555.04 397.16 550.18 397.16 550.18 398.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="484.58 397.16 479.72 397.16 479.72 398.37 484.58 398.37 484.58 397.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="550.18"
					y1="411.73"
					x2="555.04"
					y2="411.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.04"
					y1="411.73"
					x2="555.04"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.04"
					y1="410.52"
					x2="550.18"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.18"
					y1="410.52"
					x2="550.18"
					y2="411.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.58"
					y1="410.52"
					x2="479.72"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.72"
					y1="410.52"
					x2="479.72"
					y2="411.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.72"
					y1="411.73"
					x2="484.58"
					y2="411.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.58"
					y1="411.73"
					x2="484.58"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.18"
					y1="398.37"
					x2="555.04"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.04"
					y1="398.37"
					x2="555.04"
					y2="397.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.04"
					y1="397.16"
					x2="550.18"
					y2="397.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.18"
					y1="397.16"
					x2="550.18"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.58"
					y1="397.16"
					x2="479.72"
					y2="397.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.72"
					y1="397.16"
					x2="479.72"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.72"
					y1="398.37"
					x2="484.58"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.58"
					y1="398.37"
					x2="484.58"
					y2="397.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="548.97 410.52 550.79 410.52 550.79 398.37 548.97 398.37 548.97 410.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="483.97 410.52 485.79 410.52 485.79 398.37 483.97 398.37 483.97 410.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="530.46 353.7 485.79 398.37 488.8 401.37 533.47 356.7 530.46 353.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="550.79"
					y1="398.37"
					x2="551.4"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.79"
					y1="410.52"
					x2="551.4"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.4"
					y1="398.37"
					x2="551.4"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.97"
					y1="398.37"
					x2="483.36"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.97"
					y1="410.52"
					x2="483.36"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.36"
					y1="398.37"
					x2="483.36"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.97"
					y1="410.52"
					x2="548.97"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.97"
					y1="398.37"
					x2="550.79"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.79"
					y1="398.37"
					x2="550.79"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.79"
					y1="410.52"
					x2="548.97"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.97"
					y1="410.52"
					x2="483.97"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.97"
					y1="398.37"
					x2="485.79"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.79"
					y1="398.37"
					x2="485.79"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.79"
					y1="410.52"
					x2="483.97"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.46"
					y1="353.7"
					x2="533.47"
					y2="356.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.47"
					y1="356.7"
					x2="488.8"
					y2="401.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.8"
					y1="401.37"
					x2="485.79"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.79"
					y1="398.37"
					x2="530.46"
					y2="353.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.4"
					y1="398.37"
					x2="551.4"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.4"
					y1="398.37"
					x2="551.4"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.4"
					y1="398.37"
					x2="555.04"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.4"
					y1="398.37"
					x2="555.04"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.4"
					y1="410.52"
					x2="555.04"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.4"
					y1="410.52"
					x2="555.04"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="398.37"
					x2="483.36"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="398.37"
					x2="483.36"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="398.37"
					x2="479.72"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="398.37"
					x2="479.72"
					y2="398.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="410.52"
					x2="479.72"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="483.36"
					y1="410.52"
					x2="479.72"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="409.31"
					y1="500.08"
					x2="551.6"
					y2="500.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="561.67"
					y1="487.93"
					x2="475.22"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.07"
					y1="487.93"
					x2="409.31"
					y2="487.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="570.75"
					y1="573.35"
					x2="570.75"
					y2="726.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="570.75"
					y1="561.2"
					x2="563.75"
					y2="561.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.6"
					y1="573.35"
					x2="570.75"
					y2="573.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.6"
					y1="573.35"
					x2="551.6"
					y2="561.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="551.6"
					y1="500.08"
					x2="551.6"
					y2="561.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="475.22"
					y1="487.93"
					x2="475.22"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="911.06"
					y1="152.95"
					x2="911.06"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="575.6"
					y1="172.38"
					x2="596.05"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="719.92"
					y1="172.38"
					x2="719.92"
					y2="152.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="575.6"
					y1="152.95"
					x2="575.6"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.46"
					y1="172.38"
					x2="428.46"
					y2="152.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="284.19"
					y1="152.95"
					x2="284.19"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="506.94 673.76 505.01 678.1 504.34 682.8 505.01 687.5 506.94 691.84 509.4 694.7 512.48 696.86 519.71 699.62 525.72 700.58 531.79 700.22 537.63 698.54 545.61 699.21 552.89 702.53 554.94 703.84 559.16 705.38 563.65 705.15 565.42 704.45 570.14 704.45 570.14 702.48 567.99 702.48 569.98 699.19 570.75 695.42 570.75 670.18 569.44 665.3 565.96 661.64 561.16 660.07 560.58 660.07 557.55 660.57 552.77 663.13 545.58 666.43 537.69 667.09 531.83 665.39 525.74 665.01 519.71 665.99 512.48 668.74 509.4 670.91 506.94 673.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="548.32"
					y1="691.79"
					x2="548.32"
					y2="673.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.75"
					y1="670.18"
					x2="570.75"
					y2="682.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.84"
					y1="670.18"
					x2="569.84"
					y2="682.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.75"
					y1="695.42"
					x2="570.75"
					y2="682.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.84"
					y1="695.42"
					x2="569.84"
					y2="682.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.32"
					y1="674.27"
					x2="551.68"
					y2="674.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.68"
					y1="674.27"
					x2="551.68"
					y2="677.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.68"
					y1="677.05"
					x2="548.32"
					y2="677.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.32"
					y1="691.33"
					x2="551.68"
					y2="691.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.68"
					y1="691.33"
					x2="551.68"
					y2="688.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.68"
					y1="688.55"
					x2="548.32"
					y2="688.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.79"
					y1="702.48"
					x2="570.14"
					y2="702.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.79"
					y1="704.45"
					x2="570.14"
					y2="704.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.14"
					y1="704.45"
					x2="570.14"
					y2="702.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.79"
					y1="704.45"
					x2="561.79"
					y2="702.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.34"
					y1="682.8"
					x2="504.68"
					y2="679.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="679.78"
					x2="505.46"
					y2="676.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.46"
					y1="676.87"
					x2="506.94"
					y2="673.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.94"
					y1="673.76"
					x2="509.4"
					y2="670.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.4"
					y1="670.9"
					x2="512.48"
					y2="668.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.48"
					y1="668.74"
					x2="515.99"
					y2="667.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.99"
					y1="667.14"
					x2="519.71"
					y2="665.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.71"
					y1="665.99"
					x2="522.7"
					y2="665.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.7"
					y1="665.33"
					x2="525.73"
					y2="664.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.73"
					y1="664.94"
					x2="528.76"
					y2="664.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.76"
					y1="664.88"
					x2="531.79"
					y2="665.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.79"
					y1="665.22"
					x2="536.48"
					y2="666.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.48"
					y1="666.59"
					x2="541.02"
					y2="668.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.02"
					y1="668.71"
					x2="545.07"
					y2="671.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.07"
					y1="671.24"
					x2="548.32"
					y2="673.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.69"
					y1="667.09"
					x2="541.91"
					y2="667.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.91"
					y1="667.06"
					x2="546"
					y2="666.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546"
					y1="666.36"
					x2="548.21"
					y2="665.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.21"
					y1="665.65"
					x2="550.4"
					y2="664.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.4"
					y1="664.62"
					x2="553.58"
					y2="662.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.58"
					y1="662.59"
					x2="556.88"
					y2="660.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.88"
					y1="660.8"
					x2="560.09"
					y2="660.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.09"
					y1="660.09"
					x2="563.3"
					y2="660.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.3"
					y1="660.36"
					x2="564.81"
					y2="660.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.81"
					y1="660.86"
					x2="566.21"
					y2="661.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.21"
					y1="661.61"
					x2="567.47"
					y2="662.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.47"
					y1="662.59"
					x2="568.56"
					y2="663.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.56"
					y1="663.81"
					x2="569.75"
					y2="665.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.75"
					y1="665.97"
					x2="570.41"
					y2="668.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.41"
					y1="668.03"
					x2="570.75"
					y2="670.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.84"
					y1="670.18"
					x2="569.75"
					y2="669.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.75"
					y1="669.21"
					x2="569.14"
					y2="667.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.14"
					y1="667.23"
					x2="567.66"
					y2="665.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.66"
					y1="665.48"
					x2="565.6"
					y2="664.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.6"
					y1="664.38"
					x2="562.89"
					y2="663.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.89"
					y1="663.86"
					x2="560.1"
					y2="663.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.1"
					y1="663.74"
					x2="558.71"
					y2="663.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.71"
					y1="663.75"
					x2="557.61"
					y2="664.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.61"
					y1="664.34"
					x2="557.29"
					y2="665.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.29"
					y1="665.02"
					x2="555.12"
					y2="672.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="672.66"
					x2="554.47"
					y2="676.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.47"
					y1="676.45"
					x2="554.2"
					y2="680.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.2"
					y1="680.29"
					x2="554.2"
					y2="682.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.63"
					y1="698.54"
					x2="541.86"
					y2="698.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.86"
					y1="698.57"
					x2="545.98"
					y2="699.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.98"
					y1="699.26"
					x2="548.2"
					y2="699.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.2"
					y1="699.96"
					x2="550.4"
					y2="700.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.4"
					y1="700.98"
					x2="553.59"
					y2="703"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.59"
					y1="703"
					x2="556.88"
					y2="704.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.88"
					y1="704.79"
					x2="559.02"
					y2="705.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.02"
					y1="705.39"
					x2="561.23"
					y2="705.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.23"
					y1="705.53"
					x2="563.4"
					y2="705.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.4"
					y1="705.22"
					x2="565.42"
					y2="704.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.84"
					y1="695.42"
					x2="569.75"
					y2="696.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.75"
					y1="696.38"
					x2="569.14"
					y2="698.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.14"
					y1="698.37"
					x2="567.66"
					y2="700.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.66"
					y1="700.12"
					x2="565.6"
					y2="701.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.6"
					y1="701.22"
					x2="562.89"
					y2="701.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.89"
					y1="701.74"
					x2="560.1"
					y2="701.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.1"
					y1="701.87"
					x2="558.71"
					y2="701.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.71"
					y1="701.85"
					x2="557.61"
					y2="701.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.61"
					y1="701.26"
					x2="557.29"
					y2="700.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.29"
					y1="700.58"
					x2="555.12"
					y2="692.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="692.94"
					x2="554.47"
					y2="689.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.47"
					y1="689.15"
					x2="554.2"
					y2="685.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.2"
					y1="685.31"
					x2="554.2"
					y2="682.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.34"
					y1="682.8"
					x2="504.68"
					y2="685.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="685.81"
					x2="505.46"
					y2="688.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.46"
					y1="688.73"
					x2="506.94"
					y2="691.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.94"
					y1="691.84"
					x2="509.4"
					y2="694.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.4"
					y1="694.7"
					x2="512.48"
					y2="696.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.48"
					y1="696.86"
					x2="515.99"
					y2="698.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.99"
					y1="698.46"
					x2="519.71"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.71"
					y1="699.62"
					x2="522.7"
					y2="700.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.7"
					y1="700.27"
					x2="525.73"
					y2="700.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.73"
					y1="700.66"
					x2="528.76"
					y2="700.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.76"
					y1="700.72"
					x2="531.79"
					y2="700.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.79"
					y1="700.38"
					x2="536.48"
					y2="699.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.48"
					y1="699.01"
					x2="541.02"
					y2="696.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.02"
					y1="696.89"
					x2="545.07"
					y2="694.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.07"
					y1="694.36"
					x2="548.32"
					y2="691.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.13"
					y1="661.65"
					x2="554.44"
					y2="662.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.44"
					y1="662.13"
					x2="553.41"
					y2="663.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.41"
					y1="663.52"
					x2="553.17"
					y2="664.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.17"
					y1="664.73"
					x2="552.51"
					y2="672.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.51"
					y1="672.48"
					x2="552.21"
					y2="680.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.21"
					y1="680.26"
					x2="552.21"
					y2="682.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.13"
					y1="703.95"
					x2="554.44"
					y2="703.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.44"
					y1="703.47"
					x2="553.41"
					y2="702.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.41"
					y1="702.08"
					x2="553.17"
					y2="700.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.17"
					y1="700.87"
					x2="552.51"
					y2="693.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.51"
					y1="693.12"
					x2="552.21"
					y2="685.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.21"
					y1="685.35"
					x2="552.21"
					y2="682.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.99"
					y1="702.48"
					x2="568.56"
					y2="701.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.56"
					y1="701.79"
					x2="569.75"
					y2="699.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.75"
					y1="699.63"
					x2="570.41"
					y2="697.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.41"
					y1="697.57"
					x2="570.75"
					y2="695.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="524.52 573.35 524.52 639.59 570.75 639.59 570.75 573.35 524.52 573.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="524.52"
					y1="573.35"
					x2="524.52"
					y2="639.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.75"
					y1="573.35"
					x2="570.75"
					y2="639.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.52"
					y1="639.59"
					x2="570.75"
					y2="639.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.52"
					y1="573.35"
					x2="570.75"
					y2="573.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.84"
					y1="573.35"
					x2="568.84"
					y2="639.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.88"
					y1="582.17"
					x2="534.88"
					y2="630.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.88"
					y1="630.77"
					x2="564.04"
					y2="630.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.04"
					y1="630.77"
					x2="564.04"
					y2="582.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.04"
					y1="582.17"
					x2="534.88"
					y2="582.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.97"
					y1="580.26"
					x2="532.97"
					y2="632.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.97"
					y1="632.68"
					x2="565.95"
					y2="632.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.95"
					y1="632.68"
					x2="565.95"
					y2="580.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.95"
					y1="580.26"
					x2="532.97"
					y2="580.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m560.33,606.47c0-1.59-1.28-2.87-2.87-2.87s-2.87,1.28-2.87,2.87,1.28,2.87,2.87,2.87,2.87-1.28,2.87-2.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="568.79 604.08 564.77 604.46 563.86 604.77 558.8 605.41 558.13 605.76 557.86 606.47 558.13 607.18 558.8 607.53 563.86 608.16 564.77 608.48 568.79 608.86 570.19 608.4 571.06 607.21 571.06 605.73 570.19 604.53 568.79 604.08"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m568.79,604.08c1.32,0,2.39,1.07,2.39,2.39s-1.07,2.39-2.39,2.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.77"
					y1="608.48"
					x2="568.79"
					y2="608.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m564.77,608.48c-.32-.03-.64-.14-.91-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.8"
					y1="607.53"
					x2="563.86"
					y2="608.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m558.8,607.53c-.54-.07-.94-.52-.94-1.06s.4-.99.94-1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.86"
					y1="604.77"
					x2="558.8"
					y2="605.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m563.86,604.77c.27-.18.59-.28.91-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.79"
					y1="604.08"
					x2="564.77"
					y2="604.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.4"
					y1="607.77"
					x2="564.98"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.98"
					y1="605.17"
					x2="566.4"
					y2="605.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.4"
					y1="605.17"
					x2="566.4"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m564.98,607.77c-.72,0-1.3-.58-1.3-1.3s.58-1.3,1.3-1.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m563.86,608.16c-.58-.37-.93-1.01-.93-1.7s.35-1.32.93-1.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="570.75 653.64 569.78 653.64 569.78 658.5 570.75 658.5 570.75 653.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="570.75"
					y1="658.5"
					x2="570.75"
					y2="653.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.78"
					y1="658.5"
					x2="570.75"
					y2="658.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.78"
					y1="653.64"
					x2="569.78"
					y2="658.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.75"
					y1="653.64"
					x2="569.78"
					y2="653.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="570.75 711.96 570.75 707.1 569.78 707.1 569.78 711.96 570.75 711.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="569.78"
					y1="711.96"
					x2="570.75"
					y2="711.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.78"
					y1="707.1"
					x2="569.78"
					y2="711.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.75"
					y1="707.1"
					x2="569.78"
					y2="707.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.75"
					y1="711.96"
					x2="570.75"
					y2="707.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="569.78 655.58 561.88 655.58 561.88 656.56 569.78 656.56 569.78 655.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="569.78"
					y1="656.56"
					x2="569.78"
					y2="655.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.88"
					y1="656.56"
					x2="569.78"
					y2="656.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.88"
					y1="655.58"
					x2="561.88"
					y2="656.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.78"
					y1="655.58"
					x2="561.88"
					y2="655.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="569.78 710.01 569.78 709.04 561.88 709.04 561.88 710.01 569.78 710.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="561.88"
					y1="710.01"
					x2="569.78"
					y2="710.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.88"
					y1="709.04"
					x2="561.88"
					y2="710.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.78"
					y1="709.04"
					x2="561.88"
					y2="709.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.78"
					y1="710.01"
					x2="569.78"
					y2="709.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="564.31 656.56 562.36 656.56 562.36 709.04 564.31 709.04 564.31 656.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="564.31"
					y1="709.04"
					x2="564.31"
					y2="656.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.36"
					y1="709.04"
					x2="564.31"
					y2="709.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.36"
					y1="656.56"
					x2="562.36"
					y2="709.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.31"
					y1="656.56"
					x2="562.36"
					y2="656.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.31"
					y1="573.35"
					x2="551.6"
					y2="573.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.6"
					y1="500.08"
					x2="409.31"
					y2="500.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.6"
					y1="573.35"
					x2="551.6"
					y2="500.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="542.69 564.67 542.69 509.72 418.84 509.72 418.84 564.67 542.69 564.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="418.84"
					y1="564.67"
					x2="542.69"
					y2="564.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.84"
					y1="509.72"
					x2="418.84"
					y2="564.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.69"
					y1="509.72"
					x2="418.84"
					y2="509.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.69"
					y1="564.67"
					x2="542.69"
					y2="509.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="530.52 536.71 530.56 537.21 530.68 537.69 530.88 538.13 531.15 538.54 531.49 538.89 531.88 539.17 532.31 539.38 532.76 539.51 533.23 539.56 533.71 539.51 534.17 539.38 534.59 539.17 534.98 538.89 535.32 538.54 535.59 538.13 535.79 537.69 535.91 537.21 535.95 536.71 535.91 536.22 535.79 535.74 535.59 535.29 535.32 534.89 534.98 534.54 534.59 534.25 534.17 534.04 533.71 533.92 533.23 533.87 532.76 533.92 532.31 534.04 531.88 534.25 531.49 534.54 531.15 534.89 530.88 535.29 530.68 535.74 530.56 536.22 530.52 536.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="530.56"
					y1="536.22"
					x2="530.52"
					y2="536.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.68"
					y1="535.74"
					x2="530.56"
					y2="536.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.88"
					y1="535.29"
					x2="530.68"
					y2="535.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.15"
					y1="534.89"
					x2="530.88"
					y2="535.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.49"
					y1="534.54"
					x2="531.15"
					y2="534.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.88"
					y1="534.25"
					x2="531.49"
					y2="534.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.31"
					y1="534.04"
					x2="531.88"
					y2="534.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.76"
					y1="533.92"
					x2="532.31"
					y2="534.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.23"
					y1="533.87"
					x2="532.76"
					y2="533.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.71"
					y1="533.92"
					x2="533.23"
					y2="533.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.17"
					y1="534.04"
					x2="533.71"
					y2="533.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.59"
					y1="534.25"
					x2="534.17"
					y2="534.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.98"
					y1="534.54"
					x2="534.59"
					y2="534.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.32"
					y1="534.89"
					x2="534.98"
					y2="534.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.59"
					y1="535.29"
					x2="535.32"
					y2="534.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.79"
					y1="535.74"
					x2="535.59"
					y2="535.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.91"
					y1="536.22"
					x2="535.79"
					y2="535.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.95"
					y1="536.71"
					x2="535.91"
					y2="536.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.91"
					y1="537.21"
					x2="535.95"
					y2="536.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.79"
					y1="537.69"
					x2="535.91"
					y2="537.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.59"
					y1="538.13"
					x2="535.79"
					y2="537.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.32"
					y1="538.54"
					x2="535.59"
					y2="538.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.98"
					y1="538.89"
					x2="535.32"
					y2="538.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.59"
					y1="539.17"
					x2="534.98"
					y2="538.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.17"
					y1="539.38"
					x2="534.59"
					y2="539.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.71"
					y1="539.51"
					x2="534.17"
					y2="539.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.23"
					y1="539.56"
					x2="533.71"
					y2="539.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.76"
					y1="539.51"
					x2="533.23"
					y2="539.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.31"
					y1="539.38"
					x2="532.76"
					y2="539.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.88"
					y1="539.17"
					x2="532.31"
					y2="539.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.49"
					y1="538.89"
					x2="531.88"
					y2="539.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.15"
					y1="538.54"
					x2="531.49"
					y2="538.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.88"
					y1="538.13"
					x2="531.15"
					y2="538.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.68"
					y1="537.69"
					x2="530.88"
					y2="538.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.56"
					y1="537.21"
					x2="530.68"
					y2="537.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.52"
					y1="536.71"
					x2="530.56"
					y2="537.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="545.87 534.26 546.28 534.3 546.67 534.41 547.04 534.59 547.38 534.83 547.67 535.14 547.9 535.49 548.07 535.88 548.18 536.29 548.21 536.71 548.18 537.14 548.07 537.55 547.9 537.94 547.67 538.29 547.38 538.59 547.04 538.84 546.67 539.02 546.28 539.13 545.87 539.16 541.94 538.77 541.62 538.71 541.32 538.61 541.04 538.45 536.08 537.8 535.91 537.76 535.74 537.69 535.59 537.6 535.45 537.47 535.34 537.33 535.25 537.17 535.19 536.99 535.16 536.81 535.16 536.62 535.19 536.44 535.25 536.26 535.34 536.1 535.45 535.95 535.59 535.83 535.74 535.73 535.91 535.66 536.08 535.63 541.04 534.98 541.32 534.82 541.62 534.71 541.94 534.65 545.87 534.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="545.87"
					y1="534.26"
					x2="541.94"
					y2="534.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.04"
					y1="534.98"
					x2="536.08"
					y2="535.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.08"
					y1="537.8"
					x2="541.04"
					y2="538.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.94"
					y1="538.77"
					x2="545.87"
					y2="539.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.53"
					y1="538.05"
					x2="542.14"
					y2="538.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.14"
					y1="535.38"
					x2="543.53"
					y2="535.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.53"
					y1="535.38"
					x2="543.53"
					y2="538.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m541.04,534.98c.27-.18.57-.29.89-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m536.08,537.8c-.53-.07-.92-.54-.92-1.09s.39-1.02.92-1.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m541.94,538.77c-.32-.03-.62-.14-.89-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m545.87,534.26c1.29,0,2.34,1.1,2.34,2.45s-1.05,2.45-2.34,2.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m542.14,538.05c-.7,0-1.27-.6-1.27-1.33s.57-1.33,1.27-1.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m541.04,538.45c-.57-.38-.91-1.04-.91-1.74s.34-1.36.91-1.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="131.86 457.79 76.41 457.79 76.41 512.28 131.86 512.28 131.86 457.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="131.86"
					y1="512.28"
					x2="131.86"
					y2="510.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="506.61"
					x2="131.86"
					y2="500.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="497.28"
					x2="131.86"
					y2="491.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="487.95"
					x2="131.86"
					y2="482.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="478.62"
					x2="131.86"
					y2="472.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="469.29"
					x2="131.86"
					y2="463.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="459.95"
					x2="131.86"
					y2="457.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="512.28"
					x2="79.06"
					y2="512.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.56"
					y1="512.28"
					x2="88.39"
					y2="512.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.89"
					y1="512.28"
					x2="97.72"
					y2="512.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="101.22"
					y1="512.28"
					x2="107.05"
					y2="512.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.55"
					y1="512.28"
					x2="116.38"
					y2="512.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119.88"
					y1="512.28"
					x2="125.71"
					y2="512.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.21"
					y1="512.28"
					x2="131.86"
					y2="512.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="457.79"
					x2="76.41"
					y2="459.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="463.45"
					x2="76.41"
					y2="469.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="472.79"
					x2="76.41"
					y2="478.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="482.12"
					x2="76.41"
					y2="487.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="491.45"
					x2="76.41"
					y2="497.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="500.78"
					x2="76.41"
					y2="506.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="510.11"
					x2="76.41"
					y2="512.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="457.79"
					x2="129.21"
					y2="457.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.71"
					y1="457.79"
					x2="119.88"
					y2="457.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.38"
					y1="457.79"
					x2="110.55"
					y2="457.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.05"
					y1="457.79"
					x2="101.22"
					y2="457.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.72"
					y1="457.79"
					x2="91.89"
					y2="457.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.39"
					y1="457.79"
					x2="82.56"
					y2="457.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="79.06"
					y1="457.79"
					x2="76.41"
					y2="457.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="134.73 512.07 136.4 512.07 136.4 457.99 134.73 457.99 134.73 466.48 136.1 466.48 136.1 503.59 134.73 503.59 134.73 512.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="134.73"
					y1="503.59"
					x2="134.73"
					y2="512.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="136.1"
					y1="503.59"
					x2="134.73"
					y2="503.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="136.1"
					y1="466.48"
					x2="136.1"
					y2="503.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="134.73"
					y1="466.48"
					x2="136.1"
					y2="466.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="134.73"
					y1="457.99"
					x2="134.73"
					y2="466.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="136.4"
					y1="457.99"
					x2="134.73"
					y2="457.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="136.4"
					y1="512.07"
					x2="136.4"
					y2="457.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="134.73"
					y1="512.07"
					x2="136.4"
					y2="512.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<polyline
					points="134.73 514.19 134.73 455.87 131.86 455.87 131.86 514.19 134.73 514.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="131.86"
					y1="514.19"
					x2="134.73"
					y2="514.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="131.86"
					y1="455.87"
					x2="131.86"
					y2="514.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="134.73"
					y1="455.87"
					x2="131.86"
					y2="455.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="134.73"
					y1="514.19"
					x2="134.73"
					y2="455.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="134.73"
					y1="457.99"
					x2="136.4"
					y2="457.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.4"
					y1="457.99"
					x2="136.4"
					y2="512.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.4"
					y1="512.07"
					x2="134.73"
					y2="512.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.73"
					y1="455.87"
					x2="134.73"
					y2="514.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.73"
					y1="503.59"
					x2="136.1"
					y2="503.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.1"
					y1="503.59"
					x2="136.1"
					y2="466.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.1"
					y1="466.48"
					x2="134.73"
					y2="466.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="455.87"
					x2="134.73"
					y2="455.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.73"
					y1="514.19"
					x2="131.86"
					y2="514.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.86"
					y1="514.19"
					x2="131.86"
					y2="455.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="264.23 679.62 183.74 679.62 183.74 767.7 264.23 767.7 264.23 679.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="264.23"
					y1="767.7"
					x2="264.23"
					y2="679.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.74"
					y1="767.7"
					x2="264.23"
					y2="767.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.74"
					y1="679.62"
					x2="183.74"
					y2="767.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.23"
					y1="679.62"
					x2="183.74"
					y2="679.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.23"
					y1="685.69"
					x2="183.74"
					y2="685.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="139.59 663.32 139.59 590.42 76.41 590.42 76.41 663.32 139.59 663.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="139.59"
					y1="663.32"
					x2="139.59"
					y2="590.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="663.32"
					x2="76.41"
					y2="590.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="78.32"
					y1="663.32"
					x2="78.32"
					y2="590.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.59"
					y1="663.32"
					x2="76.41"
					y2="663.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.59"
					y1="590.42"
					x2="76.41"
					y2="590.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.72"
					y1="658.53"
					x2="136.72"
					y2="595.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.72"
					y1="595.2"
					x2="134.8"
					y2="593.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.8"
					y1="593.29"
					x2="81.19"
					y2="593.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="81.19"
					y1="593.29"
					x2="79.28"
					y2="595.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="79.28"
					y1="595.2"
					x2="79.28"
					y2="658.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="79.28"
					y1="658.53"
					x2="81.19"
					y2="660.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="81.19"
					y1="660.45"
					x2="134.8"
					y2="660.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.8"
					y1="660.45"
					x2="136.72"
					y2="658.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m133.36,645.09c0-5.28-4.28-9.57-9.57-9.57s-9.57,4.28-9.57,9.57,4.28,9.57,9.57,9.57,9.57-4.28,9.57-9.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m99.38,645.09c0-3.96-3.21-7.17-7.17-7.17s-7.17,3.21-7.17,7.17,3.21,7.18,7.17,7.18,7.17-3.21,7.17-7.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m130.97,608.64c0-3.96-3.21-7.17-7.17-7.17s-7.17,3.21-7.17,7.17,3.21,7.18,7.17,7.18,7.17-3.21,7.17-7.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m101.77,608.64c0-5.28-4.28-9.57-9.57-9.57s-9.57,4.28-9.57,9.57,4.28,9.57,9.57,9.57,9.57-4.28,9.57-9.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="129.87 577.05 129.87 528.46 129.61 527.51 128.91 526.8 127.95 526.55 78.32 526.55 77.37 526.8 76.67 527.51 76.41 528.46 76.41 577.05 76.67 578.01 77.37 578.71 78.32 578.97 127.95 578.97 128.91 578.71 129.61 578.01 129.87 577.05"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m129.87,577.05c0,1.06-.86,1.91-1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="78.32"
					y1="578.97"
					x2="127.95"
					y2="578.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m78.32,578.97c-1.06,0-1.91-.86-1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.41"
					y1="528.46"
					x2="76.41"
					y2="577.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m76.41,528.46c0-1.06.86-1.91,1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.95"
					y1="526.55"
					x2="78.32"
					y2="526.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m127.95,526.55c1.06,0,1.91.86,1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.87"
					y1="577.05"
					x2="129.87"
					y2="528.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.08"
					y1="572.27"
					x2="125.08"
					y2="533.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.17"
					y1="531.33"
					x2="87.89"
					y2="531.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.98"
					y1="533.25"
					x2="85.98"
					y2="572.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.89"
					y1="574.18"
					x2="123.17"
					y2="574.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.08"
					y1="572.27"
					x2="125.08"
					y2="572.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m123.17,531.33c1.06,0,1.91.86,1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m85.98,533.25c0-1.06.86-1.91,1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m87.89,574.18c-1.06,0-1.91-.86-1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m125.08,572.27c0,1.06-.86,1.91-1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m98.41,552.76c0-1.58-1.28-2.87-2.87-2.87s-2.87,1.29-2.87,2.87,1.29,2.87,2.87,2.87,2.87-1.28,2.87-2.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="98.21 553.62 98.82 553.36 99.07 552.76 98.81 552.15 98.21 551.9 79.28 551.9 78.67 552.15 78.42 552.76 78.67 553.37 79.28 553.62 98.21 553.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="79.28"
					y1="553.62"
					x2="98.21"
					y2="553.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m79.28,553.62c-.48,0-.86-.39-.86-.86s.39-.86.86-.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.21"
					y1="551.9"
					x2="79.28"
					y2="551.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m98.21,551.9h0c.48,0,.86.39.86.86s-.38.86-.86.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="84.16 554.67 84.16 553.62 79.28 553.62 78.67 553.37 78.42 552.76 78.67 552.15 79.28 551.9 84.16 551.9 84.16 550.85 77.94 550.85 77.94 554.67 84.16 554.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="77.94"
					y1="554.67"
					x2="84.16"
					y2="554.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="77.94"
					y1="550.85"
					x2="77.94"
					y2="554.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.16"
					y1="550.85"
					x2="77.94"
					y2="550.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.16"
					y1="551.9"
					x2="84.16"
					y2="550.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="79.28"
					y1="551.9"
					x2="84.16"
					y2="551.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m79.28,553.62c-.48,0-.86-.39-.86-.86s.39-.86.86-.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.16"
					y1="553.62"
					x2="79.28"
					y2="553.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.16"
					y1="554.67"
					x2="84.16"
					y2="553.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="87.6 554.64 87.6 553.62 84.25 553.62 84.25 554.64 87.6 554.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="84.25"
					y1="554.64"
					x2="87.6"
					y2="554.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.25"
					y1="553.62"
					x2="84.25"
					y2="554.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.6"
					y1="553.62"
					x2="84.25"
					y2="553.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.6"
					y1="554.64"
					x2="87.6"
					y2="553.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="87.6 550.87 84.25 550.87 84.25 551.9 87.6 551.9 87.6 550.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="87.6"
					y1="551.9"
					x2="87.6"
					y2="550.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.25"
					y1="551.9"
					x2="87.6"
					y2="551.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.25"
					y1="550.87"
					x2="84.25"
					y2="551.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.6"
					y1="550.87"
					x2="84.25"
					y2="550.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.72"
					y1="435.75"
					x2="539.72"
					y2="418.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.72"
					y1="418.74"
					x2="493.55"
					y2="418.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.44"
					y1="435.75"
					x2="483.83"
					y2="435.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.83"
					y1="479.49"
					x2="549.44"
					y2="479.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.44"
					y1="479.49"
					x2="549.44"
					y2="413.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.83"
					y1="413.88"
					x2="483.83"
					y2="479.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.44"
					y1="415.09"
					x2="483.83"
					y2="415.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.55"
					y1="435.75"
					x2="493.55"
					y2="418.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.44"
					y1="413.88"
					x2="483.83"
					y2="413.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.74"
					y1="716.9"
					x2="179.06"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.56"
					y1="716.9"
					x2="169.73"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.23"
					y1="716.9"
					x2="160.4"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.9"
					y1="716.9"
					x2="151.07"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.57"
					y1="716.9"
					x2="141.74"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="138.24"
					y1="716.9"
					x2="132.41"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.91"
					y1="716.9"
					x2="123.08"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119.58"
					y1="716.9"
					x2="113.75"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.25"
					y1="716.9"
					x2="105.57"
					y2="716.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.74"
					y1="687.74"
					x2="134.73"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.17"
					y1="679.62"
					x2="186.17"
					y2="674.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.17"
					y1="674.82"
					x2="188.6"
					y2="674.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.6"
					y1="674.82"
					x2="188.6"
					y2="679.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.23"
					y1="687.74"
					x2="258.39"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.89"
					y1="687.74"
					x2="249.06"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.56"
					y1="687.74"
					x2="239.73"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.23"
					y1="687.74"
					x2="230.4"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.9"
					y1="687.74"
					x2="221.07"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.57"
					y1="687.74"
					x2="211.74"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.24"
					y1="687.74"
					x2="202.41"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.91"
					y1="687.74"
					x2="193.08"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.58"
					y1="687.74"
					x2="183.74"
					y2="687.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="716.9"
					x2="105.57"
					y2="712.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="709.42"
					x2="105.57"
					y2="703.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="700.09"
					x2="105.57"
					y2="694.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="690.76"
					x2="105.57"
					y2="684.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="681.43"
					x2="105.57"
					y2="675.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="672.1"
					x2="105.57"
					y2="666.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="662.76"
					x2="105.57"
					y2="656.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="653.43"
					x2="105.57"
					y2="647.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="644.1"
					x2="105.57"
					y2="638.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="634.77"
					x2="105.57"
					y2="628.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="625.44"
					x2="105.57"
					y2="619.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="616.11"
					x2="105.57"
					y2="610.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="606.78"
					x2="105.57"
					y2="600.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="597.45"
					x2="105.57"
					y2="591.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="588.12"
					x2="105.57"
					y2="582.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="578.79"
					x2="105.57"
					y2="572.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="569.46"
					x2="105.57"
					y2="563.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="560.13"
					x2="105.57"
					y2="554.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="550.8"
					x2="105.57"
					y2="544.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="541.47"
					x2="105.57"
					y2="535.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="532.14"
					x2="105.57"
					y2="526.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="522.8"
					x2="105.57"
					y2="516.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="513.47"
					x2="105.57"
					y2="507.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="504.14"
					x2="105.57"
					y2="498.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="494.81"
					x2="105.57"
					y2="488.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="485.48"
					x2="105.57"
					y2="479.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="476.15"
					x2="105.57"
					y2="470.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="466.82"
					x2="105.57"
					y2="460.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.57"
					y1="457.49"
					x2="105.57"
					y2="453.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.73"
					y1="687.74"
					x2="134.73"
					y2="663.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.73"
					y1="453.51"
					x2="76.41"
					y2="453.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.73"
					y1="590.42"
					x2="134.73"
					y2="453.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.73"
					y1="152.95"
					x2="284.19"
					y2="152.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.46"
					y1="152.95"
					x2="575.6"
					y2="152.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.92"
					y1="152.95"
					x2="911.06"
					y2="152.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.06"
					y1="172.38"
					x2="719.92"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.6"
					y1="172.38"
					x2="428.46"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.19"
					y1="172.38"
					x2="122.73"
					y2="172.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.72"
					y1="472.2"
					x2="493.55"
					y2="472.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.55"
					y1="472.2"
					x2="493.55"
					y2="440.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.55"
					y1="440.61"
					x2="539.72"
					y2="440.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.72"
					y1="440.61"
					x2="539.72"
					y2="472.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="268.44 826.4 268.44 845.84 244.79 845.84 244.79 787.13 164.3 787.13 164.3 765.49 56.97 765.49 56.97 472.95 50 472.95 50 152.95 122.72 152.95 122.72 172.39 69.44 172.39 69.44 453.5 76.41 453.5 76.41 746.06 183.74 746.06 183.74 767.7 264.23 767.7 264.23 826.4 268.44 826.4"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.07"
				/>
				<polygon
					points="719.92 152.95 719.92 172.39 687.81 172.39 687.81 262.46 608.2 262.46 608.2 307.5 596.05 307.5 596.05 172.39 575.6 172.39 575.6 152.95 719.92 152.95"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.07"
				/>
				<polygon
					points="950 152.95 950 564.31 615.49 564.31 615.49 746.01 416.61 746.01 416.61 845.84 360.78 845.84 360.78 826.4 397.16 826.4 397.16 703.75 409.31 703.75 409.31 726.58 570.76 726.58 570.76 573.34 551.6 573.34 551.6 500.09 409.31 500.09 409.31 625.99 397.16 625.99 397.16 483.09 409.31 483.09 409.31 487.93 463.07 487.93 463.07 410.52 409.31 410.52 409.31 415.04 397.16 415.04 397.16 398.37 483.36 398.37 483.36 410.52 475.22 410.52 475.22 487.93 561.67 487.93 561.67 410.52 551.39 410.52 551.39 398.37 596.05 398.37 596.05 385.25 608.2 385.25 608.2 478.18 622.83 478.18 622.83 490.32 608.2 490.32 608.2 544.86 769.19 544.86 769.19 490.32 750.39 490.32 750.39 478.18 797.83 478.18 797.83 490.32 781.34 490.32 781.34 544.86 930.56 544.86 930.56 490.32 925.39 490.32 925.39 478.18 930.56 478.18 930.56 172.39 911.06 172.39 911.06 152.95 950 152.95"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.07"
				/>
				<polygon
					points="284.19 172.38 284.19 152.95 428.46 152.95 428.46 172.38 284.19 172.38 284.19 172.38"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.07"
				/>
			</g>
			<g id="text">
				<path d="m95.74,490.12v-11.27h3.88c.88,0,1.55.05,2.01.16.65.15,1.2.42,1.65.81.59.5,1.04,1.15,1.33,1.93.3.78.45,1.67.45,2.68,0,.86-.1,1.62-.3,2.28-.2.66-.46,1.21-.77,1.65-.31.43-.66.77-1.03,1.02-.37.25-.82.43-1.35.56-.52.13-1.13.19-1.81.19h-4.07Zm1.49-1.33h2.41c.74,0,1.33-.07,1.75-.21.43-.14.76-.33,1.02-.58.35-.35.63-.83.82-1.42.2-.6.3-1.33.3-2.18,0-1.18-.19-2.08-.58-2.71-.38-.64-.85-1.06-1.41-1.28-.4-.15-1.04-.23-1.93-.23h-2.37v8.61Zm11.85,1.33l-2.99-11.27h1.53l1.72,7.39c.18.77.34,1.54.48,2.31.29-1.2.46-1.9.51-2.08l2.15-7.61h1.8l1.62,5.71c.41,1.42.7,2.75.88,3.99.14-.71.33-1.53.56-2.45l1.77-7.24h1.5l-3.09,11.27h-1.44l-2.38-8.59c-.2-.72-.32-1.16-.35-1.32-.12.52-.23.96-.33,1.32l-2.39,8.59h-1.52Z" />
				<path d="m220.42,730.41h-1.58l-1.9-3.18c-.17-.3-.34-.55-.51-.75-.16-.21-.33-.38-.51-.51-.17-.13-.35-.23-.55-.28-.2-.06-.42-.09-.66-.09h-1.09v4.83h-1.33v-11.35h3.39c.5,0,.95.06,1.37.19.42.12.79.31,1.09.56.31.25.55.57.73.95.17.37.26.81.26,1.32,0,.4-.06.76-.18,1.09-.12.33-.28.62-.51.88-.22.26-.48.48-.79.66-.31.18-.65.32-1.04.42v.03c.19.08.35.18.49.29.14.11.28.23.4.38.13.15.25.32.37.51.13.18.27.4.42.65l2.13,3.41Zm-6.8-10.14v4.11h1.8c.33,0,.64-.05.92-.15.28-.1.53-.24.74-.43.21-.19.37-.42.48-.69.12-.27.17-.58.17-.92,0-.61-.2-1.08-.59-1.42-.39-.34-.96-.51-1.7-.51h-1.82Zm14.55,6.42h-5.72c.02.9.26,1.6.73,2.09.46.49,1.1.74,1.91.74.91,0,1.75-.3,2.52-.9v1.22c-.71.52-1.65.78-2.82.78s-2.04-.37-2.7-1.1c-.65-.74-.98-1.77-.98-3.11,0-1.26.36-2.29,1.07-3.08.72-.8,1.61-1.19,2.67-1.19s1.88.34,2.46,1.03c.58.69.87,1.64.87,2.86v.68Zm-1.33-1.1c0-.75-.19-1.33-.55-1.75-.35-.42-.85-.62-1.48-.62s-1.13.22-1.56.66c-.43.44-.69,1.01-.79,1.72h4.38Zm7.15-6.03c-.25-.14-.54-.21-.86-.21-.91,0-1.36.57-1.36,1.72v1.25h1.9v1.11h-1.9v6.99h-1.29v-6.99h-1.38v-1.11h1.38v-1.31c0-.85.25-1.52.74-2.01.49-.5,1.1-.74,1.84-.74.4,0,.71.05.94.14v1.17Z" />
				<path d="m235.36,730.59c-.24,0-.45-.09-.63-.26-.17-.17-.25-.38-.25-.63s.08-.45.25-.62c.17-.18.38-.27.63-.27s.46.09.63.27c.17.17.26.38.26.62s-.09.45-.26.63-.39.26-.63.26Z" />
				<path d="m470.31,653.75v-17.62h5.01c1.52,0,2.73.37,3.62,1.12.89.75,1.34,1.72,1.34,2.91,0,1-.27,1.87-.81,2.6-.54.74-1.29,1.26-2.24,1.57v.05c1.19.14,2.14.59,2.85,1.35.71.75,1.07,1.74,1.07,2.95,0,1.51-.54,2.73-1.62,3.66s-2.44,1.4-4.09,1.4h-5.14Zm2.06-15.75v5.69h2.11c1.13,0,2.02-.27,2.67-.81.65-.55.97-1.32.97-2.31,0-1.71-1.13-2.57-3.38-2.57h-2.37Zm0,7.54v6.34h2.8c1.21,0,2.15-.29,2.81-.86.67-.57,1.01-1.36,1.01-2.36,0-2.08-1.42-3.12-4.25-3.12h-2.37Zm21.08,8.21h-2.01v-1.97h-.05c-.88,1.51-2.17,2.26-3.87,2.26-1.25,0-2.24-.33-2.95-1-.7-.66-1.06-1.54-1.06-2.64,0-2.35,1.38-3.72,4.15-4.1l3.77-.53c0-2.14-.86-3.21-2.59-3.21-1.52,0-2.88.52-4.1,1.55v-2.06c1.24-.79,2.66-1.18,4.28-1.18,2.96,0,4.44,1.56,4.44,4.69v8.18Zm-2.01-6.36l-3.03.42c-.93.13-1.64.36-2.11.7-.48.33-.71.91-.71,1.76,0,.61.22,1.12.65,1.51.44.38,1.03.58,1.76.58,1,0,1.82-.35,2.47-1.04.66-.7.98-1.59.98-2.67v-1.25Zm11.65,6.24c-.48.26-1.1.39-1.88.39-2.2,0-3.3-1.23-3.3-3.69v-7.45h-2.16v-1.72h2.16v-3.07l2.01-.65v3.72h3.17v1.72h-3.17v7.09c0,.84.14,1.45.43,1.81.29.36.76.54,1.43.54.51,0,.95-.14,1.31-.42v1.72Zm13.13.12h-2.01v-7.25c0-2.62-.97-3.93-2.92-3.93-.98,0-1.81.38-2.48,1.14-.67.75-1.01,1.72-1.01,2.91v7.13h-2.01v-18.63h2.01v8.13h.05c.97-1.59,2.34-2.38,4.13-2.38,2.83,0,4.25,1.71,4.25,5.12v7.75Z" />
				<path d="m315.58,740.07h-9.34v-17.62h8.94v1.87h-6.88v5.86h6.36v1.86h-6.36v6.17h7.27v1.87Zm13.58,0h-2.01v-7.17c0-2.67-.97-4.01-2.92-4.01-1.01,0-1.84.38-2.51,1.14-.66.75-.98,1.71-.98,2.86v7.17h-2.01v-12.58h2.01v2.09h.05c.95-1.59,2.33-2.38,4.13-2.38,1.38,0,2.43.45,3.16,1.34.73.88,1.09,2.17,1.09,3.85v7.69Zm9.65-.12c-.48.26-1.1.39-1.88.39-2.2,0-3.3-1.23-3.3-3.69v-7.45h-2.16v-1.72h2.16v-3.07l2.01-.65v3.72h3.17v1.72h-3.17v7.09c0,.84.14,1.45.43,1.81.29.36.76.54,1.43.54.51,0,.95-.14,1.31-.42v1.72Zm9.27-10.42c-.35-.27-.86-.41-1.52-.41-.86,0-1.58.41-2.16,1.22-.57.81-.86,1.92-.86,3.32v6.41h-2.01v-12.58h2.01v2.59h.05c.29-.88.72-1.57,1.31-2.06.59-.5,1.25-.75,1.98-.75.52,0,.93.06,1.2.17v2.09Zm12.23-2.04l-5.79,14.6c-1.03,2.6-2.48,3.91-4.35,3.91-.52,0-.96-.05-1.31-.16v-1.81c.43.15.83.22,1.19.22,1.02,0,1.78-.61,2.29-1.82l1.01-2.38-4.91-12.56h2.24l3.4,9.68c.04.12.13.44.26.96h.07c.04-.2.12-.51.25-.93l3.58-9.71h2.09Z" />
				<path d="m724.32,327.39v-17.62h5.01c1.52,0,2.73.37,3.62,1.12.89.75,1.34,1.72,1.34,2.91,0,1-.27,1.87-.81,2.6-.54.74-1.29,1.26-2.24,1.57v.05c1.19.14,2.14.59,2.85,1.35.71.75,1.07,1.74,1.07,2.95,0,1.51-.54,2.73-1.62,3.66-1.08.93-2.44,1.4-4.09,1.4h-5.14Zm2.06-15.75v5.69h2.11c1.13,0,2.02-.27,2.67-.81.65-.55.97-1.32.97-2.31,0-1.71-1.13-2.57-3.38-2.57h-2.37Zm0,7.54v6.34h2.8c1.21,0,2.15-.29,2.81-.86.67-.57,1.01-1.36,1.01-2.36,0-2.08-1.42-3.12-4.25-3.12h-2.37Zm22.17,2.42h-8.88c.03,1.4.41,2.48,1.13,3.24.72.76,1.71,1.14,2.97,1.14,1.42,0,2.72-.47,3.91-1.4v1.89c-1.11.8-2.57,1.2-4.39,1.2s-3.17-.57-4.19-1.71c-1.02-1.15-1.52-2.76-1.52-4.83,0-1.96.55-3.55,1.66-4.78,1.11-1.24,2.49-1.86,4.14-1.86s2.92.53,3.82,1.6c.9,1.06,1.35,2.54,1.35,4.44v1.06Zm-2.06-1.71c0-1.16-.29-2.07-.85-2.72-.55-.65-1.31-.97-2.3-.97s-1.76.34-2.42,1.02c-.66.68-1.07,1.57-1.23,2.67h6.79Zm15.83,7.49h-2.01v-2.14h-.05c-.93,1.62-2.38,2.43-4.32,2.43-1.58,0-2.85-.56-3.8-1.68-.94-1.13-1.41-2.67-1.41-4.61,0-2.08.52-3.75,1.57-5,1.05-1.25,2.44-1.88,4.19-1.88s2.99.68,3.77,2.04h.05v-7.79h2.01v18.62Zm-2.01-5.69v-1.86c0-1.02-.34-1.88-1.01-2.58-.67-.7-1.52-1.06-2.56-1.06-1.23,0-2.19.45-2.9,1.35-.7.9-1.06,2.15-1.06,3.73,0,1.45.34,2.6,1.01,3.44.68.84,1.59,1.25,2.73,1.25s2.03-.41,2.73-1.22c.7-.81,1.06-1.83,1.06-3.07Zm12.63-4.85c-.35-.27-.86-.41-1.52-.41-.86,0-1.58.41-2.16,1.22-.57.81-.86,1.92-.86,3.32v6.41h-2.01v-12.58h2.01v2.59h.05c.29-.88.72-1.57,1.31-2.06.59-.5,1.25-.75,1.98-.75.52,0,.93.06,1.2.17v2.09Zm7.43,10.84c-1.86,0-3.35-.59-4.46-1.76-1.11-1.18-1.66-2.74-1.66-4.68,0-2.11.58-3.76,1.73-4.95s2.72-1.78,4.68-1.78,3.34.58,4.39,1.73c1.06,1.15,1.58,2.76,1.58,4.8s-.57,3.62-1.71,4.83c-1.13,1.2-2.65,1.81-4.56,1.81Zm.15-11.47c-1.29,0-2.32.44-3.07,1.33-.75.88-1.13,2.09-1.13,3.64s.38,2.67,1.14,3.53c.76.86,1.78,1.29,3.06,1.29s2.3-.42,3-1.27c.7-.84,1.06-2.04,1.06-3.6s-.35-2.78-1.06-3.64c-.7-.85-1.7-1.28-3-1.28Zm14.57,11.47c-1.86,0-3.35-.59-4.46-1.76-1.11-1.18-1.66-2.74-1.66-4.68,0-2.11.58-3.76,1.73-4.95s2.72-1.78,4.68-1.78,3.34.58,4.39,1.73c1.06,1.15,1.58,2.76,1.58,4.8s-.57,3.62-1.71,4.83c-1.13,1.2-2.65,1.81-4.56,1.81Zm.15-11.47c-1.29,0-2.32.44-3.07,1.33-.75.88-1.13,2.09-1.13,3.64s.38,2.67,1.14,3.53c.76.86,1.78,1.29,3.06,1.29s2.3-.42,3-1.27c.7-.84,1.06-2.04,1.06-3.6s-.35-2.78-1.06-3.64c-.7-.85-1.7-1.28-3-1.28Zm27.18,11.18h-2.01v-7.22c0-1.39-.22-2.4-.65-3.02-.43-.62-1.15-.93-2.16-.93-.86,0-1.59.39-2.2,1.18-.6.79-.9,1.73-.9,2.83v7.17h-2.01v-7.47c0-2.47-.95-3.71-2.86-3.71-.88,0-1.61.37-2.19,1.12-.57.74-.86,1.7-.86,2.89v7.17h-2.01v-12.58h2.01v1.99h.05c.89-1.52,2.2-2.29,3.91-2.29.86,0,1.61.24,2.25.72.64.48,1.08,1.1,1.31,1.88.93-1.74,2.33-2.6,4.18-2.6,2.77,0,4.15,1.71,4.15,5.12v7.75Z" />
				<path d="m729.36,353.5h-1.47v-11.07c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.13-.59.22-.88.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.1Zm9.88,0h-1.47v-11.07c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.13-.59.22-.88.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.1Z" />
				<rect x="744.11" y="340.68" width="1.3" height="3.99" />
				<path d="m753.27,353.5h-1.47v-11.07c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.13-.59.22-.88.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.1Z" />
				<path d="m759.43,340.68v3.99h-1.3v-3.99h1.3Zm2.97,0v3.99h-1.3v-3.99h1.3Z" />
				<path d="m777.04,344.34l-3.07,4.63,3.02,4.52h-1.71l-1.8-2.97c-.11-.18-.25-.42-.4-.7h-.04c-.03.05-.17.29-.42.7l-1.83,2.97h-1.69l3.12-4.49-2.98-4.66h1.71l1.77,3.13c.13.23.26.47.38.71h.04l2.29-3.84h1.62Z" />
				<path d="m788.76,353.5h-1.47v-11.07c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.13-.59.22-.88.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.1Zm12.52-6.46c0,1.07-.1,2.02-.29,2.85-.19.83-.47,1.53-.84,2.1-.36.57-.81,1-1.35,1.3-.53.29-1.13.44-1.81.44-.64,0-1.22-.14-1.72-.42-.5-.29-.92-.7-1.27-1.24-.35-.54-.61-1.21-.79-1.99-.18-.79-.27-1.7-.27-2.72,0-1.12.09-2.11.28-2.97.19-.86.47-1.58.83-2.15.36-.58.81-1.02,1.35-1.31.54-.3,1.16-.45,1.86-.45,2.69,0,4.03,2.19,4.03,6.57Zm-1.5.14c0-3.65-.87-5.47-2.6-5.47-1.83,0-2.74,1.86-2.74,5.57,0,3.46.9,5.19,2.69,5.19s2.65-1.76,2.65-5.29Z" />
				<rect x="803.5" y="340.68" width="1.3" height="3.99" />
				<path d="m815.33,349.43c0,.63-.1,1.2-.3,1.72-.2.52-.48.98-.84,1.36-.36.38-.78.68-1.28.89-.49.21-1.03.31-1.61.31-.64,0-1.22-.13-1.73-.4-.51-.27-.94-.65-1.3-1.15-.35-.51-.62-1.12-.8-1.85-.18-.73-.28-1.55-.28-2.46,0-1.11.12-2.12.37-3.03.25-.91.6-1.69,1.05-2.33.46-.65,1.01-1.15,1.65-1.5.64-.35,1.36-.53,2.15-.53.88,0,1.59.12,2.13.37v1.39c-.66-.34-1.36-.51-2.09-.51-.57,0-1.09.13-1.55.38-.46.26-.85.62-1.18,1.09-.33.46-.58,1.03-.76,1.69-.17.66-.26,1.4-.26,2.21h.04c.59-1.07,1.56-1.6,2.92-1.6.56,0,1.06.1,1.51.29.45.19.84.46,1.15.81.32.35.57.76.74,1.24.17.48.26,1.02.26,1.61Zm-1.5.19c0-.45-.06-.85-.17-1.21-.11-.36-.28-.66-.49-.91-.21-.25-.47-.44-.78-.57-.31-.14-.66-.21-1.05-.21-.36,0-.7.07-1.01.21-.31.14-.58.32-.8.56-.23.23-.41.51-.54.82-.13.31-.19.64-.19.99,0,.44.06.85.19,1.24.13.38.3.71.53,1,.23.29.49.51.8.68.32.16.66.24,1.05.24s.71-.07,1.01-.21c.3-.14.56-.34.78-.59.21-.25.38-.55.5-.89.12-.35.18-.74.18-1.16Z" />
				<path d="m818.83,340.68v3.99h-1.3v-3.99h1.3Zm2.97,0v3.99h-1.3v-3.99h1.3Z" />
				<path d="m172.84,581.29h-2.87l-6.81-8.06c-.25-.3-.41-.51-.47-.61h-.05v8.67h-2.06v-17.62h2.06v8.28h.05c.11-.18.27-.38.47-.6l6.59-7.68h2.57l-7.56,8.45,8.08,9.17Zm3.07-15.77c-.36,0-.67-.12-.92-.37-.25-.25-.38-.56-.38-.93s.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.57.38-.93.38Zm.98,15.77h-2.01v-12.58h2.01v12.58Zm9.89-.12c-.48.26-1.1.39-1.88.39-2.2,0-3.3-1.23-3.3-3.69v-7.45h-2.16v-1.72h2.16v-3.07l2.01-.65v3.72h3.17v1.72h-3.17v7.09c0,.84.14,1.45.43,1.81.29.36.76.54,1.43.54.51,0,.95-.14,1.31-.42v1.72Zm11.25-.45c-.97.58-2.11.87-3.44.87-1.79,0-3.24-.58-4.35-1.74-1.1-1.17-1.65-2.69-1.65-4.55,0-2.07.59-3.73,1.78-4.99,1.19-1.26,2.77-1.89,4.75-1.89,1.11,0,2.08.2,2.92.61v2.06c-.93-.66-1.93-.98-3-.98-1.29,0-2.34.46-3.17,1.39-.82.92-1.23,2.13-1.23,3.62s.38,2.64,1.15,3.49c.78.85,1.82,1.28,3.12,1.28,1.1,0,2.13-.36,3.1-1.09v1.92Zm13.47.58h-2.01v-7.25c0-2.62-.97-3.93-2.92-3.93-.98,0-1.81.38-2.48,1.14-.67.75-1.01,1.72-1.01,2.91v7.13h-2.01v-18.62h2.01v8.13h.05c.97-1.59,2.34-2.38,4.13-2.38,2.83,0,4.25,1.71,4.25,5.12v7.75Zm13.89-5.79h-8.88c.03,1.4.41,2.48,1.13,3.24.72.76,1.71,1.14,2.97,1.14,1.42,0,2.72-.47,3.91-1.4v1.89c-1.11.8-2.57,1.2-4.39,1.2s-3.17-.57-4.19-1.71c-1.02-1.15-1.52-2.76-1.52-4.83,0-1.96.55-3.55,1.66-4.78,1.11-1.24,2.49-1.86,4.14-1.86s2.92.53,3.82,1.6c.9,1.06,1.35,2.54,1.35,4.44v1.06Zm-2.06-1.71c0-1.16-.29-2.07-.85-2.72-.55-.65-1.31-.97-2.3-.97s-1.76.34-2.42,1.02c-.66.68-1.07,1.57-1.23,2.67h6.79Zm15.54,7.49h-2.01v-7.17c0-2.67-.97-4.01-2.92-4.01-1.01,0-1.84.38-2.51,1.14-.66.75-.98,1.71-.98,2.86v7.17h-2.01v-12.58h2.01v2.09h.05c.95-1.59,2.33-2.38,4.13-2.38,1.38,0,2.43.45,3.16,1.34.73.88,1.09,2.17,1.09,3.85v7.69Z" />
				<path d="m231.92,310.48h-9.14v-17.62h2.06v15.75h7.08v1.87Zm3.46-15.77c-.36,0-.67-.12-.92-.37s-.38-.56-.38-.93.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.57.38-.93.38Zm.98,15.77h-2.01v-12.58h2.01v12.58Zm13.95-12.58l-5.01,12.58h-1.98l-4.77-12.58h2.21l3.19,9.14c.24.67.38,1.26.44,1.76h.05c.08-.63.21-1.2.39-1.71l3.34-9.19h2.13Zm3.18-3.19c-.36,0-.67-.12-.92-.37s-.38-.56-.38-.93.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.57.38-.93.38Zm.98,15.77h-2.01v-12.58h2.01v12.58Zm14.51,0h-2.01v-7.17c0-2.67-.97-4.01-2.92-4.01-1.01,0-1.84.38-2.51,1.14-.66.75-.98,1.71-.98,2.86v7.17h-2.01v-12.58h2.01v2.09h.05c.95-1.59,2.33-2.38,4.13-2.38,1.38,0,2.43.45,3.16,1.34.73.88,1.09,2.17,1.09,3.85v7.69Zm14.52-1.01c0,4.62-2.21,6.93-6.63,6.93-1.56,0-2.92-.29-4.08-.88v-2.01c1.42.79,2.77,1.18,4.05,1.18,3.1,0,4.64-1.65,4.64-4.94v-1.38h-.05c-.96,1.61-2.4,2.41-4.32,2.41-1.56,0-2.83-.56-3.78-1.67-.95-1.12-1.43-2.63-1.43-4.51,0-2.14.51-3.84,1.54-5.1,1.03-1.26,2.44-1.89,4.23-1.89s2.95.68,3.77,2.04h.05v-1.74h2.01v11.57Zm-2.01-4.68v-1.86c0-1-.34-1.86-1.02-2.57-.67-.71-1.51-1.07-2.52-1.07-1.24,0-2.22.45-2.92,1.36-.7.9-1.06,2.17-1.06,3.8,0,1.4.34,2.52,1.01,3.37.68.84,1.58,1.25,2.69,1.25s2.05-.4,2.75-1.2c.71-.8,1.07-1.83,1.07-3.08Z" />
				<polygon points="295.53 292.86 287.08 313.4 285.2 313.4 293.63 292.86 295.53 292.86" />
				<path d="m297.58,310.48v-17.62h4.87c6.21,0,9.31,2.86,9.31,8.59,0,2.72-.86,4.91-2.59,6.56-1.72,1.65-4.03,2.47-6.92,2.47h-4.67Zm2.06-15.75v13.88h2.63c2.31,0,4.11-.62,5.39-1.86s1.93-2.99,1.93-5.26c0-4.51-2.4-6.77-7.2-6.77h-2.75Zm16.26-.02c-.36,0-.67-.12-.92-.37-.25-.25-.38-.56-.38-.93s.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.57.38-.93.38Zm.98,15.77h-2.01v-12.58h2.01v12.58Zm14.44,0h-2.01v-7.17c0-2.67-.97-4.01-2.92-4.01-1.01,0-1.84.38-2.51,1.14-.66.75-.98,1.71-.98,2.86v7.17h-2.01v-12.58h2.01v2.09h.05c.95-1.59,2.33-2.38,4.13-2.38,1.38,0,2.43.45,3.16,1.34.73.88,1.09,2.17,1.09,3.85v7.69Zm4.75-15.77c-.36,0-.67-.12-.92-.37s-.38-.56-.38-.93.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.57.38-.93.38Zm.98,15.77h-2.01v-12.58h2.01v12.58Zm14.44,0h-2.01v-7.17c0-2.67-.97-4.01-2.92-4.01-1.01,0-1.84.38-2.51,1.14-.66.75-.98,1.71-.98,2.86v7.17h-2.01v-12.58h2.01v2.09h.05c.95-1.59,2.33-2.38,4.13-2.38,1.38,0,2.43.45,3.16,1.34.73.88,1.09,2.17,1.09,3.85v7.69Zm14.46-1.01c0,4.62-2.21,6.93-6.63,6.93-1.56,0-2.92-.29-4.08-.88v-2.01c1.42.79,2.77,1.18,4.05,1.18,3.1,0,4.64-1.65,4.64-4.94v-1.38h-.05c-.96,1.61-2.4,2.41-4.32,2.41-1.56,0-2.83-.56-3.78-1.67-.95-1.12-1.43-2.62-1.43-4.51,0-2.14.51-3.84,1.54-5.1,1.03-1.26,2.44-1.89,4.23-1.89s2.95.68,3.77,2.04h.05v-1.74h2.01v11.57Zm-2.01-4.68v-1.86c0-1-.34-1.86-1.02-2.57-.67-.71-1.51-1.07-2.52-1.07-1.24,0-2.22.45-2.92,1.36-.7.9-1.06,2.17-1.06,3.8,0,1.4.34,2.52,1.01,3.37.68.84,1.58,1.25,2.69,1.25s2.05-.4,2.75-1.2c.71-.8,1.07-1.83,1.07-3.08Z" />
				<path d="m390.04,310.48h-2.46l-2.95-4.94c-.27-.46-.53-.85-.79-1.17-.25-.33-.52-.59-.79-.8-.26-.2-.55-.35-.86-.44-.3-.1-.65-.15-1.03-.15h-1.7v7.49h-2.06v-17.62h5.26c.77,0,1.48.1,2.13.29.66.19,1.22.48,1.7.87.48.39.86.88,1.13,1.47.27.58.41,1.27.41,2.05,0,.61-.09,1.18-.28,1.7-.18.51-.44.96-.79,1.36-.34.4-.75.75-1.23,1.03-.48.28-1.01.5-1.61.65v.05c.29.13.55.28.76.45.22.16.43.36.63.59s.39.49.58.79c.2.29.41.62.65,1.01l3.3,5.3Zm-10.57-15.75v6.39h2.8c.52,0,.99-.08,1.43-.23.44-.16.82-.38,1.14-.66.32-.29.57-.65.75-1.07.18-.43.27-.9.27-1.43,0-.94-.31-1.67-.92-2.2-.61-.53-1.49-.8-2.64-.8h-2.83Zm17.89,16.05c-1.86,0-3.35-.59-4.46-1.76-1.11-1.18-1.66-2.74-1.66-4.68,0-2.11.58-3.76,1.73-4.95,1.15-1.19,2.72-1.78,4.68-1.78s3.34.58,4.39,1.73c1.06,1.15,1.58,2.76,1.58,4.8s-.57,3.62-1.71,4.83c-1.13,1.2-2.65,1.81-4.56,1.81Zm.15-11.47c-1.29,0-2.32.44-3.07,1.33-.75.88-1.13,2.09-1.13,3.64s.38,2.67,1.14,3.53c.76.86,1.78,1.29,3.06,1.29s2.3-.42,3-1.27c.7-.84,1.06-2.04,1.06-3.6s-.35-2.78-1.06-3.64c-.7-.85-1.7-1.28-3-1.28Zm14.52,11.47c-1.86,0-3.35-.59-4.46-1.76-1.11-1.18-1.66-2.74-1.66-4.68,0-2.11.58-3.76,1.73-4.95,1.15-1.19,2.72-1.78,4.68-1.78s3.34.58,4.39,1.73c1.06,1.15,1.58,2.76,1.58,4.8s-.57,3.62-1.71,4.83c-1.13,1.2-2.65,1.81-4.56,1.81Zm.15-11.47c-1.29,0-2.32.44-3.07,1.33-.75.88-1.13,2.09-1.13,3.64s.38,2.67,1.14,3.53c.76.86,1.78,1.29,3.06,1.29s2.3-.42,3-1.27c.7-.84,1.06-2.04,1.06-3.6s-.35-2.78-1.06-3.64c-.7-.85-1.7-1.28-3-1.28Zm27.12,11.18h-2.01v-7.22c0-1.39-.22-2.4-.65-3.02-.43-.62-1.15-.93-2.16-.93-.86,0-1.59.39-2.2,1.18-.6.79-.9,1.73-.9,2.83v7.17h-2.01v-7.47c0-2.47-.95-3.71-2.86-3.71-.88,0-1.61.37-2.19,1.12-.57.74-.86,1.7-.86,2.89v7.17h-2.01v-12.58h2.01v1.99h.05c.89-1.52,2.2-2.29,3.91-2.29.86,0,1.61.24,2.25.72.64.48,1.08,1.1,1.31,1.88.93-1.74,2.33-2.6,4.18-2.6,2.77,0,4.15,1.71,4.15,5.12v7.75Z" />
				<path d="m291.79,336.59h-1.47v-11.07c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.13-.59.22-.88.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.1Zm4.21-3.57c0-.34.05-.68.16-1.02.11-.35.26-.67.46-.97.2-.3.45-.57.74-.81.3-.24.63-.44,1.01-.58-.55-.31-.99-.71-1.32-1.19-.33-.49-.49-1.03-.49-1.62,0-.47.09-.91.27-1.3.18-.4.44-.74.76-1.04.32-.29.7-.52,1.14-.68.44-.17.92-.25,1.43-.25s1,.08,1.44.25.82.4,1.14.69c.32.29.57.64.75,1.04s.27.83.27,1.3c0,.59-.16,1.13-.49,1.62-.33.48-.76.88-1.3,1.19.37.14.7.34.99.58.29.24.54.52.73.81.2.3.36.62.46.97.11.34.16.68.16,1.02,0,.56-.1,1.07-.3,1.54-.2.46-.49.86-.86,1.2-.36.33-.8.58-1.31.77-.51.18-1.07.28-1.68.28s-1.16-.09-1.67-.28c-.51-.18-.94-.44-1.31-.77-.37-.33-.66-.73-.87-1.2-.2-.46-.3-.98-.3-1.54Zm1.59-.13c0,.4.06.76.18,1.08.13.32.3.6.52.82.23.23.5.4.81.53.32.12.68.18,1.06.18s.72-.06,1.04-.19c.32-.13.59-.3.81-.53.23-.23.41-.5.54-.82.13-.32.2-.68.2-1.07,0-.36-.06-.69-.19-1-.12-.32-.29-.59-.52-.83-.23-.24-.5-.43-.81-.56-.32-.14-.67-.21-1.06-.21-.37,0-.71.07-1.03.2-.31.13-.58.3-.81.54-.23.23-.41.5-.54.82-.13.32-.2.66-.2,1.05Zm.46-5.94c0,.3.05.59.16.85.11.26.27.48.46.68.2.19.42.34.68.46.26.11.53.16.82.16s.57-.06.82-.17c.26-.11.49-.27.68-.46.19-.2.34-.42.46-.68.11-.26.17-.54.17-.84s-.06-.6-.17-.86c-.11-.26-.26-.49-.45-.68-.19-.19-.42-.34-.68-.45-.26-.11-.53-.17-.83-.17-.32,0-.6.06-.87.17-.26.11-.48.27-.67.46-.18.19-.33.42-.43.68-.1.26-.15.54-.15.84Z" />
				<rect x="306.54" y="323.77" width="1.3" height="3.99" />
				<path d="m315.7,336.59h-1.47v-11.07c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.13-.59.22-.88.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.1Z" />
				<path d="m321.86,323.77v3.99h-1.3v-3.99h1.3Zm2.97,0v3.99h-1.3v-3.99h1.3Z" />
				<path d="m339.47,327.44l-3.07,4.63,3.02,4.52h-1.71l-1.8-2.97c-.11-.18-.25-.42-.4-.7h-.04c-.03.05-.17.29-.42.7l-1.83,2.97h-1.69l3.12-4.49-2.98-4.66h1.71l1.77,3.13c.13.23.26.47.38.71h.04l2.29-3.84h1.62Z" />
				<path d="m353.69,329.41c0,1.17-.12,2.22-.35,3.14-.23.91-.57,1.69-1.02,2.32-.45.63-.99,1.11-1.64,1.45-.64.33-1.38.49-2.2.49s-1.59-.15-2.23-.45v-1.4c.71.4,1.47.6,2.27.6.58,0,1.09-.12,1.55-.36.46-.24.85-.58,1.16-1.04.32-.46.56-1.02.72-1.69s.25-1.43.25-2.3h-.04c-.55,1.1-1.5,1.65-2.86,1.65-.55,0-1.05-.1-1.51-.29-.46-.2-.85-.47-1.19-.82-.33-.36-.59-.78-.78-1.27-.18-.49-.28-1.03-.28-1.62,0-.63.1-1.21.3-1.73.21-.52.49-.97.86-1.35.37-.38.8-.68,1.3-.88.51-.21,1.06-.31,1.65-.31.64,0,1.21.13,1.71.39.5.26.92.63,1.26,1.13.34.49.6,1.11.78,1.83.18.73.27,1.56.27,2.49Zm-1.58-1.31c0-.49-.07-.94-.2-1.35-.13-.41-.3-.75-.53-1.04-.23-.29-.5-.52-.81-.67-.31-.16-.65-.24-1.02-.24s-.68.07-.98.21c-.3.14-.57.33-.8.59-.22.25-.4.55-.53.9-.13.35-.19.72-.19,1.13,0,.45.06.86.18,1.22.13.36.3.66.53.91.23.24.5.43.81.56.32.13.68.2,1.06.2.34,0,.66-.06.96-.19.3-.13.57-.3.79-.52.23-.22.4-.48.53-.77.13-.3.2-.62.2-.96Z" />
				<rect x="356.06" y="323.77" width="1.3" height="3.99" />
				<path d="m359.55,333.01c0-.34.05-.68.16-1.02.11-.35.26-.67.46-.97.2-.3.45-.57.74-.81.3-.24.63-.44,1.01-.58-.55-.31-.99-.71-1.32-1.19-.33-.49-.49-1.03-.49-1.62,0-.47.09-.91.27-1.3.18-.4.44-.74.76-1.04.32-.29.7-.52,1.14-.68.44-.17.92-.25,1.43-.25s1,.08,1.44.25c.44.17.82.4,1.14.69.32.29.57.64.75,1.04.18.4.27.83.27,1.3,0,.59-.16,1.13-.49,1.62-.33.48-.76.88-1.3,1.19.37.14.7.34.99.58s.54.52.73.81c.2.3.36.62.46.97.11.34.16.68.16,1.02,0,.56-.1,1.07-.3,1.54-.2.46-.49.86-.86,1.2-.36.33-.8.58-1.31.77-.51.18-1.07.28-1.68.28s-1.16-.09-1.67-.28c-.51-.18-.94-.44-1.31-.77-.37-.33-.66-.73-.87-1.2-.2-.46-.3-.98-.3-1.54Zm1.59-.13c0,.4.06.76.18,1.08.13.32.3.6.52.82.23.23.5.4.81.53.32.12.68.18,1.06.18s.72-.06,1.04-.19c.32-.13.59-.3.81-.53.23-.23.41-.5.54-.82.13-.32.2-.68.2-1.07,0-.36-.06-.69-.19-1-.12-.32-.29-.59-.52-.83-.23-.24-.5-.43-.81-.56-.32-.14-.67-.21-1.06-.21-.37,0-.71.07-1.03.2-.31.13-.58.3-.81.54-.23.23-.41.5-.54.82-.13.32-.2.66-.2,1.05Zm.46-5.94c0,.3.05.59.16.85.11.26.27.48.46.68.2.19.42.34.68.46.26.11.53.16.82.16s.57-.06.82-.17c.26-.11.49-.27.68-.46.19-.2.34-.42.46-.68.11-.26.17-.54.17-.84s-.06-.6-.17-.86c-.11-.26-.26-.49-.45-.68-.19-.19-.42-.34-.68-.45-.26-.11-.53-.17-.83-.17-.32,0-.6.06-.87.17-.26.11-.48.27-.67.46-.18.19-.33.42-.43.68-.1.26-.15.54-.15.84Z" />
				<path d="m371.38,323.77v3.99h-1.3v-3.99h1.3Zm2.97,0v3.99h-1.3v-3.99h1.3Z" />
				<path d="m515.22,451.87l-3.16,11.2h-1.54l-2.31-8.19c-.1-.35-.16-.73-.18-1.14h-.03c-.03.39-.1.76-.2,1.13l-2.32,8.2h-1.52l-3.28-11.2h1.45l2.38,8.6c.1.36.16.73.19,1.13h.04c.03-.28.11-.65.24-1.13l2.48-8.6h1.26l2.38,8.66c.08.3.15.65.19,1.05h.03c.02-.27.09-.63.21-1.08l2.29-8.63h1.42Z" />
				<polygon points="521.76 451.87 516.39 464.93 515.19 464.93 520.55 451.87 521.76 451.87" />
				<path d="m523.07,463.07v-11.2h3.09c3.95,0,5.92,1.82,5.92,5.46,0,1.73-.55,3.12-1.65,4.17-1.09,1.05-2.56,1.57-4.4,1.57h-2.97Zm1.31-10.02v8.83h1.67c1.47,0,2.61-.39,3.43-1.18.82-.79,1.23-1.9,1.23-3.34,0-2.87-1.53-4.31-4.58-4.31h-1.75Z" />
			</g>
		</g>
	)
}

export default PlanO
